
import About1 from "../assets/images/new/about1.png";
import panditBooking from "../assets/images/new/panditBooking.jpg";
import PujaBookingBannerImg from "../assets/images/new/PoojaBookingbannerImg.png";

import DailyPooja from "../assets/images/new/DailyPooja.jpg";
import DailyPujaBookingBannerImg from "../assets/images/new/DailyPoojaBookingBannerImg.png";
import { FaBoxOpen, FaHandshake, FaHome, FaRegCalendarCheck, FaTools, FaUserCheck } from 'react-icons/fa';
import { t } from "i18next";

import EstoreBannerImg from "../assets/images/new/E-Storebanner.png";
import HoroscopeBannerImg from "../assets/images/new/HoroscopeBanner.png";
import PujaAtTempleBannerImg from "../assets/images/new/PujaAtTempleBannerImg.png";
import prasadBooking from "../assets/images/new/prasad-booking.png";
import DarshanBookingBannerImg from "../assets/images/new/DarshanBookingBannerImg.png";
import Ecart from "../assets/images/new/e-cart.jpg";
import Horoscope from "../assets/images/new/Horoscope.jpg";
import LandingPujaKit from "../assets/images/new/LandingPujaKit.jpg";
import poojaAtTemple from "../assets/images/new/poojaAtTemple.jpg";
import templeBooking from "../assets/images/new/templeBooking.jpg";

export const ServiceDiscounts = {
  panditBookingDiscount: 18,
  DailyBookingDiscount: 18,
  PujaAtTemple: 18,
  darshanBooking: 18
};


export const FaqModuleID = {
  PujaBooking: 1,
  DailyPujaBooking: 2,
  DarshanBooking: 3,
  PujaAtTempleBooking: 4,
  EstoreBooking: 5,
  PrasadBooking: 6
}
export const langID = {
  English: 1,
  Hindi: 2,
  Marathi: 3,
  Tamil: 4,
  Kannada: 5,
  Malayalam: 6,
  Gujarati: 7
}

export const pujaServiceID = {
  Puja: 1,
  SankalpPuja: 2,
  PanditPuja: 3,
  Temple: 4,
  Ecommerce: 5,
  Blog: 6
}

export const pujaSubServiceID = {
  RemedyPuja: 1,
  HomamPuja: 2,
  SubscriptionRemedyPuja: 3,
  SubscriptionHomamPuja: 4,
  PanditPuja: 5,
  DailyPanditPuja: 6,
  PujaAtTemple: 7,
  Prasad: 8,
  DarshanBooking: 9,
  LiveDarshan: 10,
  Product: 11,
  Blog: 12
}
export const PaymentTypeID = {
  COD: 1,
  Online: 2,
  Both: 3,
  
}




export const landingPageEnglishContent = [
  // Remedy Puja 
  {
    headerName: "Book Remedy Puja Online",
    Imgabout1: About1,
    Imgabout2: panditBooking,
    tagLine: "Receive Divine Blessings",
    route: "/remedy-puja",
    serviceBannerImg: PujaBookingBannerImg,
    sectionTitle: "Book Remedy Puja to Experience Peace",
    serviceName: "remedy-puja",
    howItWorksMainHeading: "Easy Steps to Receive Remedy Puja Blessings",
    howItWorks: [
      {
        howItWorksTitle: "Select Your Remedy Puja",
        howItWorksDesc:
          "Choose the remedy puja you wish to perform, whether for health, career, relationships, peace, or overall spiritual balance.",
      },
      {
        howItWorksTitle: "Book Your Ritual",
        howItWorksDesc:
          "Our expert pandits perform every remedy puja with devotion and follow authentic Vedic procedures to ensure maximum effectiveness and positive energy.",
      },
      {
        howItWorksTitle: "Receive Divine Healing",
        howItWorksDesc:
          "Feel the sacred vibrations, connect with divine energy, and invite blessings for health, happiness, prosperity, and spiritual well-being into your life.",
      },
    ],
    testimonials: [
      {
        Desc: "I booked a Satyanarayan Puja through Myomnamo, and everything was perfectly arranged. The pandit was knowledgeable, punctual, and performed the rituals with devotion. Highly recommended.",
        name: "Rajesh Singh",
        location: "Delhi",
      },
      {
        Desc: " My Griha Pravesh Puja was conducted beautifully. The pandit arrived on time with all the required materials. The entire process was smooth and blessed. Thank you, Myomnamo.",
        name: "Priya Mane",
        location: "Nashik",
      },
      {
        Desc: "I needed a Navagraha Shanti puja, and Myomnamo made it so easy! The chanting, rituals, and arrangements were all done perfectly. Truly a divine experience.",
        name: "Amit Kapoor",
        location: "Mumbai",
      },
      {
        Desc: "Myomnamo  helped me organize a puja at my house during Navratri. The whole process was smooth, and the pandit performed all the rituals properly.",
        name: "Rajesh Kulkarni",
        location: "Nashik",
      },
    ],
    FaqObj: [
      {
        question: "Can I customize my remedy puja?",
        answer:
          "Yes, our pandits can personalize the puja according to your needs and intentions.",
        color: "#ffa415",
      },
      {
        question: "How quickly can the puja be scheduled?",
        answer:
          "Pujas can be arranged quickly, with urgent bookings available depending on pandit availability.",
        color: "#fc5528",
      },
      {
        question: "Do you provide prasadam?",
        answer:
          "Yes, after the puja, non-perishable prasadam is delivered to your home.",
        color: "#8139e7",
      },
      {
        question: "What if I cannot attend live?",
        answer:
          "No worries! You’ll receive video recordings and photos of the puja to cherish later.",
        color: "#8139e7",
      },
      {
        question: "Can the puja be performed at home or a temple?",
        answer:
          "Yes, our pandits perform the remedy puja at home, temple, or online with full devotion and proper Vedic rituals.",
        color: "#8139e7",
      },
      // {
      //   question: "Why is it important How Volunteer?",
      //   answer:
      //     "There are many variations of passages the majority have suffered alteration in some form injected humour, or randomised words.",
      //   color: "#399be7",
      // },
    ],
    whychooseUs: [
      {
        title: 'Pure Vedic Rituals',
        description: 'Performed with devotion by experienced pandits to invoke divine blessings.'
      },
      {
        title: 'Easy Puja Booking',
        description: 'Choose and book your remedy puja from home in a few simple steps.'
      },
      {
        title: 'Join Live or Receive Recordings',
        description: 'Feel the sacred energy online or receive videos and photos to cherish.'
      },
      {
        title: 'All Puja Materials Provided',
        description: 'Everything you need is included, so you can focus on your prayers.'
      },
      {
        title: 'Clear and Fair Pricing',
        description: 'No hidden costs, just a pure and worry-free spiritual experience.'
      },
      {
        title: 'Guidance and Support',
        description: 'Our team is always ready to help you with any puja-related questions.'
      }
    ],
    whychooseUsTitle: 'Why Devotees Trust Our Remedy Puja?',
    metaTitle: "Book Puja Online - Experienced Pandits for All Ceremonies",
    metaDescription:
      "Book a pandit for weddings, housewarming, or any puja. Ensure sacred rituals are performed with care, devotion, and tradition. Start your booking now!",
    cannonicalLink: "https://www.myomnamo.com/services/puja-booking",
    breadcrumbSchema: {
      "@context": "https://schema.org/",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.myomnamo.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Puja Booking",
          item: "https://www.myomnamo.com/services/puja-booking",
        },
      ],
    },

    webpageSchema: {
      "@context": "http://schema.org",
      "@type": "WebPage",
      name: "Book Puja Online - Experienced Pandits for All Ceremonies",
      url: "https://www.myomnamo.com/services/puja-booking",
      description:
        "Book a pandit for weddings, housewarming, or any puja. Ensure sacred rituals are performed with care, devotion, and tradition. Start your booking now!",
      publisher: {
        "@type": "Organization",
        name: "Myomnamo",
      },
    },

    faqSchema: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "What types of puja’s can I book?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "You can book a variety of rituals, including Ganpati puja, Navratri Aarti, Lakshmi puja, and more.",
          },
        },
        {
          "@type": "Question",
          name: "Can I book recurring pujas?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Absolutely! You can schedule daily, weekly, or multi-day rituals as per your needs.",
          },
        },
        {
          "@type": "Question",
          name: "Are the pandits experienced and qualified?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, all our pandits are experienced, well-trained, and follow proper Vedic rituals.",
          },
        },
        {
          "@type": "Question",
          name: "Can I book a puja for a temple or home location?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, you can book a puja for your home, temple, or any preferred location.",
          },
        },
        {
          "@type": "Question",
          name: "Do you offer online puja services?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, we offer virtual pujas where pandits perform rituals online.",
          },
        },
      ],
    },
    metaData: {
      title: "Book Puja Online - Experienced Pandits for All Ceremonies",
      description:
        "Book a pandit for weddings, housewarming, or any puja. Ensure sacred rituals are performed with care, devotion, and tradition. Start your booking now!",
      image: "https://www.myomnamo.com/assets/images/new/logo.png",
      url: "https://www.myomnamo.com/services/puja-booking",
      siteName: "Myomnamo",
      locale: "en_IN",
    },
    mainContent:
      "Experience powerful remedy pujas performed by expert pandits to bring peace, prosperity, and spiritual healing into your life. These traditional Vedic rituals help remove obstacles, balance energies, and promote overall well-being. You can now easily book your remedy puja online and receive divine blessings from the comfort of your home or workplace, with every ceremony conducted according to authentic ancient traditions.",
  },
  // Homam Puja
  {
    headerName: "Book Homam Puja Online",
    Imgabout1: About1,
    Imgabout2: panditBooking,
    tagLine: "Feel divine presence with Homam Puja",
    route: "/homam-puja",
    serviceBannerImg: PujaBookingBannerImg,
    sectionTitle: "Book Divine Homam Puja Online for Every Occasion",
    serviceName: "homam-puja",
    howItWorksMainHeading: "Receive Blessings of the Divine",
    howItWorks: [
      {
        howItWorksTitle: "Select Your Homam Puja",
        howItWorksDesc:
          "Choose the Homam Puja you wish to perform, be it for peace, prosperity, health, housewarming, or any special occasion.",
      },
      {
        howItWorksTitle: "Book Your Ritual Easily",
        howItWorksDesc:
          "Simply book your puja, and our experienced priests will conduct every ritual with devotion and authentic Vedic tradition.",
      },
      {
        howItWorksTitle: "Receive Divine Blessings",
        howItWorksDesc:
          "Join the sacred ceremony, feel the positive vibrations, and invite blessings of health, happiness, and prosperity into your life.",
      },
    ],
    testimonials: [
      {
        Desc: "I booked a Satyanarayan Puja through Myomnamo, and everything was perfectly arranged. The pandit was knowledgeable, punctual, and performed the rituals with devotion. Highly recommended.",
        name: "Rajesh Singh",
        location: "Delhi",
      },
      {
        Desc: " My Griha Pravesh Puja was conducted beautifully. The pandit arrived on time with all the required materials. The entire process was smooth and blessed. Thank you, Myomnamo.",
        name: "Priya Mane",
        location: "Nashik",
      },
      {
        Desc: "I needed a Navagraha Shanti puja, and Myomnamo made it so easy! The chanting, rituals, and arrangements were all done perfectly. Truly a divine experience.",
        name: "Amit Kapoor",
        location: "Mumbai",
      },
      {
        Desc: "Myomnamo  helped me organize a puja at my house during Navratri. The whole process was smooth, and the pandit performed all the rituals properly.",
        name: "Rajesh Kulkarni",
        location: "Nashik",
      },
    ],
    FaqObj: [
      {
        question: "How soon can I book a homam puja?",
        answer:
          "You can book most homam pujas within a few hours, depending on priest's availability.",
        color: "#ffa415",
      },
      {
        question: "Will I receive guidance or instructions?",
        answer:
          "Yes, detailed instructions and event information are shared before the homam puja.",
        color: "#fc5528",
      },
      {
        question: "Can I join live or view recordings?",
        answer:
          "You can participate live or access video recordings and photos after the puja.",
        color: "#8139e7",
      },
      {
        question: "Is it possible to conduct a homam at home?",
        answer:
          "Yes, our priests perform rituals at your home or temple with full devotion.",
        color: "#8139e7",
      },
      {
        question: "Is it safe to book online?",
        answer:
          "Absolutely, our platform is secure and ensures a smooth, trusted booking process.",
        color: "#8139e7",
      },
      // {
      //   question: "Why is it important How Volunteer?",
      //   answer:
      //     "There are many variations of passages the majority have suffered alteration in some form injected humour, or randomised words.",
      //   color: "#399be7",
      // },
    ],
    whychooseUs: [
      {
        title: 'Easy Online Booking',
        description: 'Book your homam puja online in just a few minutes for any special occasion.'
      },
      {
        title: 'Experienced Pandit',
        description: 'A qualified pandit performs every ritual with devotion, either at home, in a temple, or via live streaming.'
      },
      {
        title: 'Choose Your Homam Puja',
        description: 'Select Ganapathi, Maha Mrityunjaya, Navagraha, and Dhanvantari Homam Puja for prosperity, health, and success.'
      },
      {
        title: 'Personalized Prayers',
        description: 'Include your name and family details in the rituals to make the ceremony meaningful.'
      },
      {
        title: 'Live and Recorded Options',
        description: 'Watch the homam live, or receive video and photo recordings to cherish the divine moments.'
      },
      {
        title: 'Complete Guidance',
        description: 'Receive clear instructions and pre-event guidance, so you know exactly what to expect.'
      }
    ],
    whychooseUsTitle: 'What Makes Our Homam Puja Unique?',
    metaTitle: "Book Puja Online - Experienced Pandits for All Ceremonies",
    metaDescription:
      "Book a pandit for weddings, housewarming, or any puja. Ensure sacred rituals are performed with care, devotion, and tradition. Start your booking now!",
    cannonicalLink: "https://www.myomnamo.com/services/puja-booking",
    breadcrumbSchema: {
      "@context": "https://schema.org/",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.myomnamo.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Puja Booking",
          item: "https://www.myomnamo.com/services/puja-booking",
        },
      ],
    },

    webpageSchema: {
      "@context": "http://schema.org",
      "@type": "WebPage",
      name: "Book Puja Online - Experienced Pandits for All Ceremonies",
      url: "https://www.myomnamo.com/services/puja-booking",
      description:
        "Book a pandit for weddings, housewarming, or any puja. Ensure sacred rituals are performed with care, devotion, and tradition. Start your booking now!",
      publisher: {
        "@type": "Organization",
        name: "Myomnamo",
      },
    },

    faqSchema: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "What types of puja’s can I book?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "You can book a variety of rituals, including Ganpati puja, Navratri Aarti, Lakshmi puja, and more.",
          },
        },
        {
          "@type": "Question",
          name: "Can I book recurring pujas?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Absolutely! You can schedule daily, weekly, or multi-day rituals as per your needs.",
          },
        },
        {
          "@type": "Question",
          name: "Are the pandits experienced and qualified?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, all our pandits are experienced, well-trained, and follow proper Vedic rituals.",
          },
        },
        {
          "@type": "Question",
          name: "Can I book a puja for a temple or home location?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, you can book a puja for your home, temple, or any preferred location.",
          },
        },
        {
          "@type": "Question",
          name: "Do you offer online puja services?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, we offer virtual pujas where pandits perform rituals online.",
          },
        },
      ],
    },
    metaData: {
      title: "Book Puja Online - Experienced Pandits for All Ceremonies",
      description:
        "Book a pandit for weddings, housewarming, or any puja. Ensure sacred rituals are performed with care, devotion, and tradition. Start your booking now!",
      image: "https://www.myomnamo.com/assets/images/new/logo.png",
      url: "https://www.myomnamo.com/services/puja-booking",
      siteName: "Myomnamo",
      locale: "en_IN",
    },
    mainContent:
      "Make your special moments sacred with the guidance of an experienced pandit. Whether it’s a wedding, housewarming, naming ceremony, or any puja, a pandit ensures each ritual is done with care and devotion. Their knowledge of traditions brings peace and positivity to your home or event. From small home ceremonies to grand events, we bring positivity and tradition to your gathering. Performing rituals, helps you connect with your faith and look for blessings for health, happiness, and prosperity. Make every ceremony special and memorable with an experienced pandit who guides each step with care and kindness.",
  },
  // Pandit Puja
  {
    headerName: "Pandit Booking Service",
    Imgabout1: About1,
    Imgabout2: panditBooking,
    tagLine: "Embrace Divinity with Temple Pujas",
    route: "/pandit-puja",
    serviceBannerImg: PujaBookingBannerImg,
    sectionTitle: "Book an Experienced Pandit for Your Puja",
    serviceName: "pandit-booking",
    howItWorksMainHeading: "Effortless Path to Divine Blessings",
    howItWorks: [
      {
        howItWorksTitle: "Select Your Ceremony",
        howItWorksDesc:
          "Choose the ritual you want to perform- a wedding, housewarming, naming ceremony, or any special puja. ",
      },
      {
        howItWorksTitle: "Book Your Puja",
        howItWorksDesc:
          "Our expert pandits ensure each ritual is conducted with care, devotion, and attention to sacred details. ",
      },
      {
        howItWorksTitle: "Embrace Sacred Vibes",
        howItWorksDesc:
          "Pandit leads your ceremony with care. Feel the divine energy, connect with your faith, and receive health, happiness, and prosperity blessings. ",
      },
    ],
    testimonials: [
      {
        Desc: "I booked a Satyanarayan Puja through Myomnamo, and everything was perfectly arranged. The pandit was knowledgeable, punctual, and performed the rituals with devotion. Highly recommended.",
        name: "Rajesh Singh",
        location: "Delhi",
      },
      {
        Desc: " My Griha Pravesh Puja was conducted beautifully. The pandit arrived on time with all the required materials. The entire process was smooth and blessed. Thank you, Myomnamo.",
        name: "Priya Mane",
        location: "Nashik",
      },
      {
        Desc: "I needed a Navagraha Shanti puja, and Myomnamo made it so easy! The chanting, rituals, and arrangements were all done perfectly. Truly a divine experience.",
        name: "Amit Kapoor",
        location: "Mumbai",
      },
      {
        Desc: "Myomnamo  helped me organize a puja at my house during Navratri. The whole process was smooth, and the pandit performed all the rituals properly.",
        name: "Rajesh Kulkarni",
        location: "Nashik",
      },
    ],
    FaqObj: [
      {
        question: "What types of puja’s can I book?",
        answer:
          "You can book a variety of rituals, including Ganpati puja, Navratri Aarti, Lakshmi puja, and more.",
        color: "#ffa415",
      },
      {
        question: "Can I book recurring pujas?",
        answer:
          "Absolutely! You can schedule daily, weekly, or multi-day rituals as per your needs.",
        color: "#fc5528",
      },
      {
        question: "Are the pandits experienced and qualified?",
        answer:
          "Yes, all our pandits are experienced, well-trained, and follow proper Vedic rituals.",
        color: "#8139e7",
      },
      {
        question: "Can I book a puja for a temple or home location?",
        answer:
          "Yes, you can book a puja for your home, temple, or any preferred location.",
        color: "#8139e7",
      },
      {
        question: "Do you offer online puja services?",
        answer:
          "Yes, we offer virtual pujas where pandits perform rituals online.",
        color: "#8139e7",
      },
      // {
      //   question: "Why is it important How Volunteer?",
      //   answer:
      //     "There are many variations of passages the majority have suffered alteration in some form injected humour, or randomised words.",
      //   color: "#399be7",
      // },
    ],

    whychooseUs: [
      {
        title: t("Verified and Experienced Pandits"),
        description:
          t("Our platform connects you with highly qualified and experienced pandits who specialise in Vedic rituals and Hindu ceremonies."),
        icon: <FaUserCheck size={40} color="#8f3246" />,
      },
      {
        title: t("Hassle-Free Booking"),
        description:
          t("Book your puja online in just a few clicks! Our user-friendly interface allows you to easily select the ceremony, date, and location."),
        icon: <FaRegCalendarCheck size={40} color="#8f3246" />,
      },
      {
        title: t("Customized Rituals"),
        description:
          t("We offer pujas in different regional styles like North Indian, South Indian, Bengali, and Marathi. Whatever your tradition, we make sure the rituals match your customs and needs."),
        icon: <FaTools size={40} color="#8f3246" />,
      },
      {
        title: t("Convenience at Your Doorstep"),
        description:
          t("Whether you need a pandit for a home ceremony or a temple ritual, we bring divine blessings to your doorstep with punctual and reliable service."),
        icon: <FaHome size={40} color="#8f3246" />,
      },
      {
        title: t("Customer Satisfaction"),
        description:
          t("With hundreds of successful pujas conducted, we pride ourselves on delivering exceptional service that leaves our customers spiritually fulfilled and happy."),
        icon: <FaHandshake size={40} color="#8f3246" />,
      },
      {
        title: t("All-Inclusive Packages"),
        description:
          t("From arranging pandits to providing puja samagri, we handle everything so you can focus on your prayers without stress."),
        icon: <FaBoxOpen size={40} color="#8f3246" />,
      },
    ],
    metaTitle: "Book Puja Online - Experienced Pandits for All Ceremonies",
    metaDescription:
      "Book a pandit for weddings, housewarming, or any puja. Ensure sacred rituals are performed with care, devotion, and tradition. Start your booking now!",
    cannonicalLink: "https://www.myomnamo.com/services/puja-booking",
    breadcrumbSchema: {
      "@context": "https://schema.org/",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.myomnamo.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Puja Booking",
          item: "https://www.myomnamo.com/services/puja-booking",
        },
      ],
    },

    webpageSchema: {
      "@context": "http://schema.org",
      "@type": "WebPage",
      name: "Book Puja Online - Experienced Pandits for All Ceremonies",
      url: "https://www.myomnamo.com/services/puja-booking",
      description:
        "Book a pandit for weddings, housewarming, or any puja. Ensure sacred rituals are performed with care, devotion, and tradition. Start your booking now!",
      publisher: {
        "@type": "Organization",
        name: "Myomnamo",
      },
    },

    faqSchema: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "What types of puja’s can I book?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "You can book a variety of rituals, including Ganpati puja, Navratri Aarti, Lakshmi puja, and more.",
          },
        },
        {
          "@type": "Question",
          name: "Can I book recurring pujas?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Absolutely! You can schedule daily, weekly, or multi-day rituals as per your needs.",
          },
        },
        {
          "@type": "Question",
          name: "Are the pandits experienced and qualified?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, all our pandits are experienced, well-trained, and follow proper Vedic rituals.",
          },
        },
        {
          "@type": "Question",
          name: "Can I book a puja for a temple or home location?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, you can book a puja for your home, temple, or any preferred location.",
          },
        },
        {
          "@type": "Question",
          name: "Do you offer online puja services?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, we offer virtual pujas where pandits perform rituals online.",
          },
        },
      ],
    },
    metaData: {
      title: "Book Puja Online - Experienced Pandits for All Ceremonies",
      description:
        "Book a pandit for weddings, housewarming, or any puja. Ensure sacred rituals are performed with care, devotion, and tradition. Start your booking now!",
      image: "https://www.myomnamo.com/assets/images/new/logo.png",
      url: "https://www.myomnamo.com/services/puja-booking",
      siteName: "Myomnamo",
      locale: "en_IN",
    },
    mainContent:
      "Make your special moments sacred with the guidance of an experienced pandit. Whether it’s a wedding, housewarming, naming ceremony, or any puja, a pandit ensures each ritual is done with care and devotion. Their knowledge of traditions brings peace and positivity to your home or event. From small home ceremonies to grand events, we bring positivity and tradition to your gathering. Performing rituals, helps you connect with your faith and look for blessings for health, happiness, and prosperity. Make every ceremony special and memorable with an experienced pandit who guides each step with care and kindness.",
  },
  // Daily Pandit Puja 
  {
    headerName: "Daily Pandit Booking Service",
    Imgabout1: About1,
    Imgabout2: DailyPooja,
    tagLine: "Embrace Divinity with Temple Pujas",
    sectionTitle: "Book a Pandit for Daily Puja at Your Convenience",
    route: "/daily-pandit-puja",
    serviceBannerImg: DailyPujaBookingBannerImg,
    serviceName: "daily-puja-booking",
    howItWorksMainHeading: "Book a Pandit for Daily Puja at Your Convenience",
    howItWorks: [
      {
        howItWorksTitle: "Choose Your Ritual",
        howItWorksDesc:
          "Whether it's Ganpati Puja, Navratri Aarti, or a simple morning prayer, select the service you need. We’ll connect you with an experienced pandit. ",
      },
      {
        howItWorksTitle: "Schedule Your Time",
        howItWorksDesc:
          "Pick a date and time that fits your routine. Pandits are available every morning and evening, so you can schedule rituals at your convenience. ",
      },
      {
        howItWorksTitle: "Experience Divine Blessings",
        howItWorksDesc:
          "Your dedicated pandit arrives with all the necessary items for the Puja. Feel peace, positivity, and divine energy fill your space.",
      },
    ],
    testimonials: [
      {
        Desc: " I booked a daily Ganesh Puja, and it has brought so much positivity to my home. The pandit performs the rituals with devotion, and everything is well-organized. Truly grateful.",
        name: "Anjali Rajput",
        location: "Mumbai",
      },
      {
        Desc: " My family wanted a daily Shiv Abhishek, and My OmNamo made it effortless. The pandit is punctual, knowledgeable, and follows proper Vedic traditions. Highly recommended.",
        name: "Suresh Kale",
        location: "Nashik",
      },
      {
        Desc: "I opted for a monthly Lakshmi Puja service, and the experience has been wonderful. The prayers are performed with sincerity, bringing peace and prosperity to our home.",
        name: "Meera Savant",
        location: "Bangalore",
      },
      {
        Desc: "A very good option by Myomnamo for working people who want to stay connected to their faith.",
        name: "Chetan Pawar",
        location: "Chandrapur",
      },
      {
        Desc: "Every morning, I get an update about the puja. It gives a positive start to my day. Grateful to Myomnamo.",
        name: "Arjun Shinde",
        location: "Jalgaon",
      },
    ],
    FaqObj: [
      {
        question: "What is a daily puja booking service?",
        answer:
          "It allows you to book a pandit for performing daily pujas at your home or temple.",
        color: "#ffa415",
      },
      {
        question: "How do I book a pandit for my ritual?",
        answer:
          "You can easily book a pandit online by selecting your ceremony, choosing a date, and confirming your booking.",
        color: "#fc5528",
      },
      {
        question: "Can I choose a specific pandit?",
        answer:
          "Yes, you can choose a pandit based on availability and your preferred language or tradition.",
        color: "#8139e7",
      },
      {
        question: "Can I schedule pujas at a fixed time daily?",
        answer:
          "Yes, you can set a fixed time for your daily puja at your convenience.",
        color: "#8139e7",
      },
      {
        question: "Can I book a virtual daily puja?",
        answer: "Yes, we offer online pujas where pandits perform rituals.",
        color: "#8139e7",
      },
      // {
      //   question: "Why is it important How Volunteer?",
      //   answer:
      //     "There are many variations of passages the majority have suffered alteration in some form injected humour, or randomised words.",
      //   color: "#399be7",
      // },
    ],

    metaTitle:
      "Daily Puja Booking Online - Trusted Pandits Morning & Evening Rituals",
    metaDescription:
      "Book an experienced pandit for your daily puja. Choose your ritual, pick a time, and welcome divine blessings to your home easily. Book now for morning or evening.",
    cannonicalLink: "https://www.myomnamo.com/services/daily-puja-booking",
    breadcrumbSchema: {
      "@context": "https://schema.org/",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.myomnamo.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Daily Puja Booking",
          item: "https://www.myomnamo.com/services/daily-puja-booking",
        },
      ],
    },
    webpageSchema: {
      "@context": "http://schema.org",
      "@type": "WebPage",
      name: "Daily Puja Booking Online - Trusted Pandits Morning & Evening Rituals",
      url: "https://www.myomnamo.com/services/daily-puja-booking",
      description:
        "Book an experienced pandit for your daily puja. Choose your ritual, pick a time, and welcome divine blessings to your home easily. Book now for morning or evening.",
      publisher: {
        "@type": "Organization",
        name: "Myomnamo",
      },
    },
    faqSchema: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "What is a daily puja booking service?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "It allows you to book a pandit for performing daily pujas at your home or temple.",
          },
        },
        {
          "@type": "Question",
          name: "How do I book a pandit for my ritual?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "You can easily book a pandit online by selecting your ceremony, choosing a date, and confirming your booking.",
          },
        },
        {
          "@type": "Question",
          name: "Can I choose a specific pandit?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, you can choose a pandit based on availability and your preferred language or tradition.",
          },
        },
        {
          "@type": "Question",
          name: "Can I schedule pujas at a fixed time daily?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, you can set a fixed time for your daily puja at your convenience.",
          },
        },
        {
          "@type": "Question",
          name: "Can I book a virtual daily puja?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, we offer online pujas where pandits perform rituals.",
          },
        },
      ],
    },
    metaData: {
      title: "Book Puja Online - Experienced Pandits for All Ceremonies",
      description:
        "Book a pandit for weddings, housewarming, or any puja. Ensure sacred rituals are performed with care, devotion, and tradition. Start your booking now!",
      image: "https://www.myomnamo.com/assets/images/new/logo.png",
      url: "https://www.myomnamo.com/services/puja-booking",
      siteName: "Myomnamo",
      locale: "en_IN",
    },
    mainContent:
      "Looking for a pandit to perform daily pujas at home or at your event? Experienced pandits are available every morning and evening to guide you through your spiritual experience with care and devotion. Whether it's a 10-day Ganpati puja, a Navratri aarti, or any multi-day ceremony, we handle each step with accuracy and respect for tradition. From chanting mantras to performing aartis, we ensure your rituals are done properly. Bring peace, positivity, and divine blessings to your space every day. Experience divine blessings every day with a trusted pandit guiding your rituals.",
  },
  // E-store
  {
    headerName: "Online Puja Samagri Store",
    Imgabout1: About1,
    Imgabout2: Ecart,
    tagLine: "Embrace Divinity with Temple Pujas",
    serviceBannerImg: EstoreBannerImg,
    route: "/my-store",
    serviceName: "e-store",
    whychooseUs: [
      {
        title: t("Authentic Products Only"),
        description: t(
          "We offer 100% authentic and traditional puja samagri sourced from trusted vendors to maintain the sanctity of rituals."
        ),

      },
      {
        title: t("All-In-One Puja Kits"),
        description: t(
          "Ready-to-use kits include every essential item needed for specific pujas, saving time and ensuring nothing is missed."
        ),

      },
      {
        title: t("Wide Range of Items"),
        description: t(
          "Explore an extensive collection of quality incense sticks, dhoop, kapur, and sacred items for every kind of puja."
        ),

      },
      {
        title: t("Nationwide Delivery"),
        description: t(
          "We deliver across India with safe packaging to preserve the purity and freshness of every puja item you order."
        ),

      },
      {
        title: t("Trusted by Devotees"),
        description: t(
          "Thousands of satisfied customers trust our service for prompt delivery and the spiritual value of our curated samagri."
        ),

      },
      {
        title: t("Easy Online Ordering"),
        description: t(
          "Enjoy a hassle-free shopping experience with secure payment options and doorstep delivery for all your spiritual needs."
        ),

      },
    ],
    whychooseUsTitle: 'Why Devotees Trust Our Our E-Store?',
    howItWorksMainHeading: "Puja Shopping Made Simple With E-store",
    howItWorks: [
      {
        howItWorksTitle: "Browse & Select",
        howItWorksDesc:
          "Explore our wide range of puja samagri. Choose puja samgari or complete puja kits customised to your spiritual needs. ",
      },
      {
        howItWorksTitle: "Order & Pay",
        howItWorksDesc:
          "Add products to your cart, securely check out, and choose convenient payment options for a smooth shopping experience. ",
      },
      {
        howItWorksTitle: "Receive & Worship",
        howItWorksDesc:
          "Get your order delivered to your door. Perform your rituals peacefully with everything you need ready and sacred.",
      },
    ],
    testimonials: [
      {
        Desc: " I ordered a Lakshmi idol and Rudraksha mala, and the quality was amazing. The items were well-packed and delivered on time. Truly satisfied.",
        name: "Puja More",
        location: "Pune",
      },
      {
        Desc: " I purchased a complete puja kit, and it made my rituals so convenient. Everything was authentic and spiritually blessed. Highly recommend.",
        name: "Vikas Rathi",
        location: "Bangalore",
      },
      {
        Desc: "I bought incense sticks and a shankha from the E-Store. The delivery was quick, and the packaging was perfect. Will shop again.",
        name: "Meenal Shinde",
        location: "Jaipur",
      },
      {
        Desc: "Shopping from Myomnamo’s E-Store was easy and convenient. I got all my puja items in one place, without needing to visit multiple shops.",
        name: "Sagar Shinde",
        location: "Mumbai",
      },
    ],
    FaqObj: [
      {
        question: "What products do you offer?",
        answer:
          "We provide puja samagri, complete kits, idols, incense, flowers, and everything needed for daily rituals or special ceremonies.",
        color: "#ffa415",
      },
      {
        question: "Do you offer fast delivery?",
        answer:
          "Yes! We ensure quick and reliable delivery so you get your items on time for your puja or festival.",
        color: "#fc5528",
      },
      {
        question: "Are the products authentic and blessed?",
        answer:
          "Yes, our products are sourced from trusted vendors and many items are spiritually blessed.",
        color: "#8139e7",
      },
    ],
    sectionTitle: "Your One-Stop Online E-Store",
    metaTitle: "Online Puja Samagri Store - Buy Puja Items at Myomnamo",
    metaDescription:
      "Online shopping for authentic Puja samagri and puja items at Myomnamo. Explore a wide range of spiritual products for all your rituals and ceremonies. Fast delivery and trusted quality.",
    cannonicalLink: "https://www.myomnamo.com/services/e-store",
    breadcrumbSchema: {
      "@context": "https://schema.org/",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.myomnamo.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Puja Samagri Store",
          item: "https://www.myomnamo.com/services/e-store",
        },
      ],
    },
    webpageSchema: {
      "@context": "http://schema.org",
      "@type": "WebPage",
      name: "Online Puja Samagri Store - Buy Puja Items at Myomnamo",
      url: "https://www.myomnamo.com/services/e-store",
      description:
        "Online shopping for authentic Puja samagri and puja items at Myomnamo. Explore a wide range of spiritual products for all your rituals and ceremonies. Fast delivery and trusted quality.",
      publisher: {
        "@type": "Organization",
        name: "Myomnamo",
      },
    },
    faqSchema: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "What products do you offer?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "We provide puja samagri, complete kits, idols, incense, flowers, and everything needed for daily rituals or special ceremonies.",
          },
        },
        {
          "@type": "Question",
          name: "Do you offer fast delivery?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes! We ensure quick and reliable delivery so you get your items on time for your puja or festival.",
          },
        },
        {
          "@type": "Question",
          name: "Are the products authentic and blessed?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, our products are sourced from trusted vendors and many items are spiritually blessed.",
          },
        },
      ],
    },
    metaData: {
      title: "Online Puja Samagri Store - Buy Puja Items at Myomnamo",
      description:
        "Online shopping for authentic Puja samagri and puja items at Myomnamo. Explore a wide range of spiritual products for all your rituals and ceremonies. Fast delivery and trusted quality.",
      image: "https://www.myomnamo.com/assets/images/new/logo.png",
      url: "https://www.myomnamo.com/services/e-store",
      siteName: "Myomnamo",
      locale: "en_IN",
    },

    mainContent:
      "Shop for all your puja needs from home. Get puja samagri, complete puja kits, idols, incense, and more. Whether it's for daily pujas or special festivals, have everything ready for your rituals. No need to visit multiple shops, just browse and get items delivered to your door.  Make every ceremony meaningful with the right products, from sacred flowers to holy offerings. Celebrate traditions easily, knowing you have everything needed for a peaceful and complete puja experience. Keep your devotion strong with the right products for every spiritual occasion.",
  },
  // Darshan Booking 
  {
    headerName: "Online Darshan Booking",
    Imgabout1: About1,
    Imgabout2: templeBooking,
    tagLine: "Embrace Divinity with Temple Pujas",
    sectionTitle: "Easy Temple Darshan Booking Online",
    serviceBannerImg: DarshanBookingBannerImg,
    serviceName: "darshan-booking",
    cannonicalLink: "https://www.myomnamo.com/services/darshan-booking",
    route: "/darshan-booking",
    howItWorksMainHeading: "Simple & Time-Saving Darshan Booking",
    howItWorks: [
      {
        howItWorksTitle: "Choose Your Temple",
        howItWorksDesc:
          "Select your temple and preferred date for darshan. Plan your visit effortlessly, even during peak times. ",
      },
      {
        howItWorksTitle: "Book Your Slot",
        howItWorksDesc:
          "Reserve your darshan slot online in minutes. Avoid long queues and secure a peaceful, hassle-free temple experience.",
      },
      {
        howItWorksTitle: "Get Confirmation",
        howItWorksDesc:
          "Receive instant booking confirmation via email or SMS. Show your details at the temple and enjoy your visit stress-free.",
      },
    ],
    testimonials: [
      {
        Desc: " Booking temple darshan online saved me so much time! No long queues and the process was smooth. Truly a divine experience.",
        name: "Rohit Pawar",
        location: "Yeola",
      },
      {
        Desc: "I booked a VIP darshan for my family, and everything went perfectly. The confirmation was instant, and we had a peaceful visit.",
        name: "Neha Tile",
        location: "Nagpur",
      },
      {
        Desc: "This service made temple visits stress-free. I booked my darshan in advance and had a smooth entry without any hassle. Highly recommended.",
        name: "Amit Patil",
        location: "Jaipur",
      },
      {
        Desc: "My elderly parents were able to do darshan without travelling. This meant a lot to us. Thank you Myomnamo.",
        name: "Bhavana Salunkhe",
        location: "Nanded",
      },

      {
        Desc: "The process was simple and the darshan was well organised by Myomnamo.",
        name: "Gaurav Jadhav",
        location: "Ratnagiri",
      },
    ],
    FaqObj: [
      {
        question: "What is the Darshan Booking service?",
        answer:
          "Our service allows you to book temple darshan online for a hassle-free spiritual experience.",
        color: "#ffa415",
      },
      {
        question: "Can I book darshan for multiple people?",
        answer:
          "Yes, you can book darshan for yourself, your family, or your friends in one go. Just add their details during booking.",
        color: "#fc5528",
      },
      {
        question: "Is online booking available for special events?",
        answer:
          "Yes, you can book darshan for festivals, special pujas, or daily visits — even during peak times.",
        color: "#8139e7",
      },
      {
        question: "Are VIP or special darshan tickets available?",
        answer:
          "Yes, we offer VIP or express darshan bookings at select temples.",
        color: "#8139e7",
      },
    ],
    metaTitle:
      "Online Temple Darshan Booking - Plan Your Visit Now with Myomnamo",
    metaDescription:
      "Book temple darshan online and avoid waiting. Secure your slot, receive instant confirmation, and focus on your prayers. Start your booking now!",
    canonicalLink: "https://www.myomnamo.com/services/darshan-booking",
    breadcrumbSchema: {
      "@context": "https://schema.org/",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.myomnamo.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Darshan Booking",
          item: "https://www.myomnamo.com/services/darshan-booking",
        },
      ],
    },
    webpageSchema: {
      "@context": "http://schema.org",
      "@type": "WebPage",
      name: "Online Temple Darshan Booking - Plan Your Visit Now with Myomnamo",
      url: "https://www.myomnamo.com/services/darshan-booking",
      description:
        "Book temple darshan online and avoid waiting. Secure your slot, receive instant confirmation, and focus on your prayers. Start your booking now!",
      publisher: {
        "@type": "Organization",
        name: "Myomnamo",
      },
    },
    faqSchema: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "What is the Darshan Booking service?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Our service allows you to book temple darshan online for a hassle-free spiritual experience.",
          },
        },
        {
          "@type": "Question",
          name: "Can I book darshan for multiple people?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, you can book darshan for yourself, your family, or your friends in one go. Just add their details during booking.",
          },
        },
        {
          "@type": "Question",
          name: "Is online booking available for special events?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, you can book darshan for festivals, special pujas, or daily visits — even during peak times.",
          },
        },
        {
          "@type": "Question",
          name: "Are VIP or special darshan tickets available?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, we offer VIP or express darshan bookings at select temples.",
          },
        },
      ],
    },
    metaData: {
      title:
        "Online Temple Darshan Booking - Plan Your Visit Now with Myomnamo",
      description:
        "Book temple darshan online and avoid waiting. Secure your slot, receive instant confirmation, and focus on your prayers. Start your booking now!",
      image: "https://www.myomnamo.com/assets/images/new/logo.png",
      url: "https://www.myomnamo.com/services/darshan-booking",
      siteName: "Myomnamo",
      locale: "en_IN",
    },
    mainContent:
      "Plan your temple visit easily! Book your darshan in advance and skip the long queues. Whether you are visiting for a festival, special puja, or daily prayers, secure your spot in just a few steps. Enjoy a peaceful visit, offer your prayers, and look for blessings without the stress of waiting. Ideal for families, elderly devotees, or anyone wanting a smooth experience. Focus on your devotion and fully immerse yourself in the sacred atmosphere. Booking your darshan makes your visit more organized, giving you more time for prayer and reflection.",
  },
  // Puja At Temple
  {
    headerName: "Temple Puja Booking",
    Imgabout1: About1,
    Imgabout2: poojaAtTemple,
    tagLine: "Embrace Divinity with Temple Pujas",
    serviceBannerImg: PujaAtTempleBannerImg,
    route: "/puja-at-temple",
    cannonicalLink: "https://www.myomnamo.com/services/temple-puja-booking",
    serviceName: "temple-puja",
    sectionTitle: "Perform a Sacred Puja at the Temple",
    whychooseUs: [
      {
        title: "Easy Booking",
        description:
          "Book any temple puja online, anytime, from anywhere, quickly, simply, and hassle-free.",
        icon: <FaRegCalendarCheck size={40} color="#8f3246" />, // Booking icon
      },
      {
        title: "Experienced Pandits",
        description:
          "Our skilled and verified pandits perform rituals with full devotion and tradition.",
        icon: <FaHandshake size={40} color="#8f3246" />, // Trust/experience icon
      },
      {
        title: "Personalized Services",
        description:
          "Choose pujas to your needs, occasions, and preferences for a meaningful spiritual experience.",
        icon: <FaTools size={40} color="#8f3246" />, // Customization icon
      },
      {
        title: "Live Updates",
        description:
          "Get real-time notifications on puja status and timing for peace of mind.",
        icon: <FaRegCalendarCheck size={40} color="#8f3246" />, // Live/update-style icon
      },
      {
        title: "Safe Payments",
        description:
          "Make secure online payments with full data encryption and protection.",
        icon: <FaBoxOpen size={40} color="#8f3246" />, // You don't have a payment icon; best alternative
      },
      {
        title: "One-Stop Spiritual Hub",
        description:
          "Access all spiritual services, pandit booking, pujas, and darshan tickets in one place.",
        icon: <FaHome size={40} color="#8f3246" />, // All-in-one hub icon
      },
    ],

    whychooseUsTitle: 'Why Devotees Trust Our Puja?',
    howItWorksMainHeading: "Receive Sacred Blessings",
    howItWorks: [
      {
        howItWorksTitle: "Choose Your Puja",
        howItWorksDesc:
          "Choose from simple offerings or elaborate ceremonies, and personalize rituals for your spiritual intentions.  ",
      },
      {
        howItWorksTitle: "Book Effortlessly",
        howItWorksDesc:
          "From gathering offerings to preparing the sacred space, we ensure everything is ready so you can focus on your prayers without any worries.",
      },
      {
        howItWorksTitle: "Experience Divinity",
        howItWorksDesc:
          "Participate in sacred rituals, chant mantras, and receive blessings for positivity and well-being.",
      },
    ],
    testimonials: [
      {
        Desc: " I booked a puja at the temple, and everything was perfectly arranged. The rituals were performed beautifully, and I felt truly blessed.",
        name: "Anjali Raut",
        location: "Kolhapur",
      },
      {
        Desc: "Booking a temple puja online was so convenient. No long waits, everything was well-organized, and the prasad delivery was a lovely touch",
        name: "Vikas Mane",
        location: "Delhi",
      },
      {
        Desc: "The puja was conducted exactly as promised, with complete devotion and care. It was a peaceful and divine experience. Highly recommended.",
        name: "Priya Kadam",
        location: "Vashi",
      },
      {
        Desc: "We wanted a puja done in a South Indian temple, and Myomnamo made it happen smoothly.",
        name: "Abhay Nadkarni",
        location: "Mumbai",
      },
      {
        Desc: "Myomnamo helped me book a special temple puja for my son’s birthday. Felt truly blessed.",
        name: "Rahul Chitale",
        location: "Solapur",
      },
    ],
    FaqObj: [
      {
        question: "What is the Puja at Temple service?",
        answer:
          "Our service allows you to book a temple puja online, ensuring a smooth and hassle-free experience.",
        color: "#ffa415",
      },
      {
        question: "How do I book a puja?",
        answer:
          "You can book online or at the temple. Choose the puja type, date, and time.",
        color: "#fc5528",
      },
      {
        question: "What types of pujas are available?",
        answer:
          "We offer pujas for birthdays, anniversaries, festivals, personal prayers, and special ceremonies.",
        color: "#8139e7",
      },
      {
        question: "Are special or private pujas available?",
        answer:
          "Yes, some temples offer private pujas with personalized rituals.",
        color: "#8139e7",
      },
    ],
    metaTitle: "Book Temple Puja Online - Sacred Rituals for Every Occasion",
    metaDescription:
      "Book a temple puja for birthdays, anniversaries, or festivals. Experience sacred rituals with care and devotion. Focus on prayers while we handle the rest.",
    canonicalLink: "https://www.myomnamo.com/services/temple-puja-booking",
    breadcrumbSchema: {
      "@context": "https://schema.org/",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.myomnamo.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Temple Puja",
          item: "https://www.myomnamo.com/services/temple-puja-booking",
        },
      ],
    },
    webpageSchema: {
      "@context": "http://schema.org",
      "@type": "WebPage",
      name: "Book Temple Puja Online - Sacred Rituals for Every Occasion",
      url: "https://www.myomnamo.com/services/temple-puja-booking",
      description:
        "Book a temple puja for birthdays, anniversaries, or festivals. Experience sacred rituals with care and devotion. Focus on prayers while we handle the rest.",
      publisher: {
        "@type": "Organization",
        name: "Myomnamo",
      },
    },
    faqSchema: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "What is the Puja at Temple service?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Our service allows you to book a temple puja online, ensuring a smooth and hassle-free experience.",
          },
        },
        {
          "@type": "Question",
          name: "How do I book a puja?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "You can book online or at the temple. Choose the puja type, date, and time.",
          },
        },
        {
          "@type": "Question",
          name: "What types of pujas are available?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "We offer pujas for birthdays, anniversaries, festivals, personal prayers, and special ceremonies.",
          },
        },
        {
          "@type": "Question",
          name: "Are special or private pujas available?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, some temples offer private pujas with personalized rituals.",
          },
        },
      ],
    },
    metaData: {
      title: "Book Temple Puja Online - Sacred Rituals for Every Occasion",
      description:
        "Book a temple puja for birthdays, anniversaries, or festivals. Experience sacred rituals with care and devotion. Focus on prayers while we handle the rest.",
      image: "https://www.myomnamo.com/assets/images/new/logo.png",
      url: "https://www.myomnamo.com/services/temple-puja-booking",
      siteName: "Myomnamo",
      locale: "en_IN",
    },
    mainContent:
      "Make your temple visit more special with a peaceful puja. Book a puja for any occasion, whether it be birthdays, anniversaries, festivals, or personal prayers. Let the rituals be performed with care and devotion, bringing positivity and blessings into your life. Whether it’s a small offering or a full ceremony, experience the divine atmosphere and connect deeply with your faith. Perfect for individuals, families, or groups looking for a sacred experience. Focus on your prayers while the arrangements are taken care of. Make every visit special and full of positive energy.",
  },
  // Horoscope
  {
    headerName: "Horoscope Reading",
    Imgabout1: About1,
    Imgabout2: Horoscope,
    tagLine: "Embrace Divinity with Temple Pujas",
    route: "/basic-details",
    serviceBannerImg: HoroscopeBannerImg,
    cannonicalLink: "https://www.myomnamo.com/services/horoscope",
    serviceName: "horoscope",
    sectionTitle: "Know What Your Stars Say",
    howItWorksMainHeading: "How Our Horoscope Reading Works",
    howItWorks: [
      {
        howItWorksTitle: "Choose Your Sign",
        howItWorksDesc:
          "Select your zodiac sign to receive a personalized reading about your life, emotions, and future possibilities.",
      },
      {
        howItWorksTitle: "Get Insights Instantly",
        howItWorksDesc:
          "Access daily, weekly, or yearly horoscopes with detailed guidance on love, career, and well-being for extra clarity.",
      },
      {
        howItWorksTitle: "Embrace Your Path",
        howItWorksDesc:
          "Use your horoscope’s advice to make decisions, discover lucky days, and invite more happiness and balance into your life.",
      },
    ],
    testimonials: [
      {
        Desc: "The personalised horoscope report I received from Myomnamo helped me understand many things about my career and personal life. Very insightful.",
        name: "Amit Dumbre",
        location: "Pune",
      },
      {
        Desc: "I wasn’t very serious about astrology before, but the weekly guidance from Myomnamo has actually helped me make better decisions.",
        name: "Vaishali Thakur",
        location: "Nagpur",
      },
      {
        Desc: "Myomnamo’s horoscope reading was detailed and easy to understand. It wasn’t too technical and gave me practical suggestions.",
        name: "Rohit Pansare",
        location: "Nashik",
      },
      {
        Desc: "I started reading the daily horoscope from Myomnamo and it gives me clarity and focus every morning. It feels very accurate and meaningful.",
        name: "Prachi Kelkar",
        location: "Mumbai",
      },
    ],
    FaqObj: [
      {
        question: "What is the Puja at Temple service?",
        answer:
          "Our service allows you to book a temple puja online, ensuring a smooth and hassle-free experience.",
        color: "#ffa415",
      },
      {
        question: "How do I book a puja?",
        answer:
          "You can book online or at the temple. Choose the puja type, date, and time.",
        color: "#fc5528",
      },
      {
        question: "What types of pujas are available?",
        answer:
          "We offer pujas for birthdays, anniversaries, festivals, personal prayers, and special ceremonies.",
        color: "#8139e7",
      },
      {
        question: "Are special or private pujas available?",
        answer:
          "Yes, some temples offer private pujas with personalized rituals.",
        color: "#8139e7",
      },
    ],
    metaTitle: "Horoscope Readings by Zodiac Sign - Know Your Future",
    metaDescription:
      "Find guidance for love, career, and life decisions with a horoscope reading. Explore daily, weekly, or yearly insights tailored to your zodiac sign. Book a consultation.",
    canonicalLink: "https://www.myomnamo.com/services/horoscope",
    breadcrumbSchema: {
      "@context": "https://schema.org/",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.myomnamo.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Horoscope",
          item: "https://www.myomnamo.com/services/horoscope",
        },
      ],
    },
    webpageSchema: {
      "@context": "http://schema.org",
      "@type": "WebPage",
      name: "Horoscope Readings by Zodiac Sign - Know Your Future",
      url: "https://www.myomnamo.com/services/horoscope",
      description:
        "Find guidance for love, career, and life decisions with a horoscope reading. Explore daily, weekly, or yearly insights tailored to your zodiac sign. Book a consultation.",
      publisher: {
        "@type": "Organization",
        name: "Myomnamo",
      },
    },
    metaData: {
      title: "Horoscope Readings by Zodiac Sign - Know Your Future",
      description:
        "Find guidance for love, career, and life decisions with a horoscope reading. Explore daily, weekly, or yearly insights tailored to your zodiac sign. Book a consultation.",
      image: "https://www.myomnamo.com/assets/images/new/logo.png",
      url: "https://www.myomnamo.com/services/horoscope",
      siteName: "Myomnamo",
      locale: "en_IN",
    },
    mainContent:
      "Find out what your future holds with a simple horoscope reading. Learn about your day, week, or year efficiently. Get insights about love, work, health, and more. Whether you have a big decision to make or are just curious, a horoscope reading can guide you. Find out lucky days, helpful advice, and ways to bring more happiness into your life. Perfect for anyone looking for extra clarity and peace of mind. Let the stars guide you toward a brighter future.",
  },
  // Prasad Booking
  {
    headerName: "Online Prasad Booking Service",
    Imgabout1: About1,
    Imgabout2: Ecart,
    tagLine: "Embrace Divinity with Temple Prasad",
    serviceBannerImg: prasadBooking,
    route: "/temple",
    serviceName: "online-prasad-booking",
    howItWorksMainHeading: "Book Prasad Online with Myomnamo",
    howItWorks: [
      {
        howItWorksTitle: "Choose & Customize",
        howItWorksDesc:
          "Select your preferred prasad, meal time, and quantity. Pick from a variety of sacred offerings prepared with devotion. ",
      },
      {
        howItWorksTitle: "Book & Pay",
        howItWorksDesc:
          "Complete your booking with a few clicks. Enjoy secure payment options for a hassle-free experience",
      },
      {
        howItWorksTitle: "Receive & Blessings",
        howItWorksDesc:
          "Get the divine prasad delivered to your home. Savour the sacred taste and feel the blessings of the divine.",
      },
    ],
    testimonials: [
      {
        Desc: " I ordered a Lakshmi idol and Rudraksha mala, and the quality was amazing. The items were well-packed and delivered on time. Truly satisfied.",
        name: "Puja More",
        location: "Pune",
      },
      {
        Desc: " I purchased a complete puja kit, and it made my rituals so convenient. Everything was authentic and spiritually blessed. Highly recommend.",
        name: "Vikas Rathi",
        location: "Bangalore",
      },
      {
        Desc: "I bought incense sticks and a shankha from the E-Store. The delivery was quick, and the packaging was perfect. Will shop again.",
        name: "Meenal Shinde",
        location: "Jaipur",
      },
      {
        Desc: "I couldn’t go to the temple, but getting prasad made me feel included. Myomnamo is doing a great job.",
        name: "Nitin Korde",
        location: "Pune",
      },
    ],
    FaqObj: [
      {
        question: "Which temples' prasad can I book?",
        answer:
          "You can book prasad from famous temples, including Tirupati Balaji, Shirdi Sai Baba, and Ayodhya Ram Mandir, all prepared with traditional devotion.",
        color: "#ffa415",
      },
      {
        question: "How long does delivery take?",
        answer:
          "Delivery time varies by location, but we ensure your prasad reaches you fresh, typically within 3-7 business days after booking.",
        color: "#fc5528",
      },
      {
        question: "Is the prasad prepared hygienically?",
        answer:
          "Yes, all prasad is prepared in temple-approved kitchens following strict hygiene and traditional methods to maintain purity and sanctity.",
        color: "#8139e7",
      },
      {
        question: "Can I book prasad for special occasions?",
        answer:
          "Absolutely! You can book prasad in bulk for festivals, pujas, or family gatherings and share divine blessings with your loved ones.",
        color: "#8139e7",
      },
    ],
    sectionTitle: "Online Prasad Booking Service",
    metaTitle: "Online Prasad Booking - Receive Divine Blessings at Home",
    metaDescription:
      "Book authentic temple prasad online and enjoy sacred blessings at home. Select your meal time and quantity for a convenient spiritual experience. Order Now!",
    cannonicalLink: "https://www.myomnamo.com/services/online-prasad-booking",
    breadcrumbSchema: {
      "@context": "https://schema.org/",
      "@type": "BreadcrumbList",

      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.myomnamo.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Online Prasad Booking",
          item: "https://www.myomnamo.com/services/online-prasad-booking",
        },
      ],
    },
    webpageSchema: {
      "@context": "http://schema.org",
      "@type": "WebPage",
      name: "Online Prasad Booking - Receive Divine Blessings at Home",
      url: "https://www.myomnamo.com/services/online-prasad-booking",
      description:
        "Book authentic temple prasad online and enjoy sacred blessings at home. Select your meal time and quantity for a convenient spiritual experience. Order Now!",
      publisher: {
        "@type": "Organization",
        name: "Myomnamo",
      },
    },
    faqSchema: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Which temples' prasad can I book?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "You can book prasad from famous temples, including Tirupati Balaji, Shirdi Sai Baba, and Ayodhya Ram Mandir, all prepared with traditional devotion.",
          },
        },
        {
          "@type": "Question",
          name: "How long does delivery take?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Delivery time varies by location, but we ensure your prasad reaches you fresh, typically within 3-7 business days after booking.",
          },
        },
        {
          "@type": "Question",
          name: "Is the prasad prepared hygienically?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, all prasad is prepared in temple-approved kitchens following strict hygiene and traditional methods to maintain purity and sanctity.",
          },
        },
        {
          "@type": "Question",
          name: "Can I book prasad for special occasions?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Absolutely! You can book prasad in bulk for festivals, pujas, or family gatherings and share divine blessings with your loved ones.",
          },
        },
      ],
    },
    metaData: {
      title: "Online Puja Samagri Store - Buy Puja Items at Myomnamo",
      description:
        "Online shopping for authentic Puja samagri and puja items at Myomnamo. Explore a wide range of spiritual products for all your rituals and ceremonies. Fast delivery and trusted quality.",
      image: "https://www.myomnamo.com/assets/images/new/logo.png",
      url: "https://www.myomnamo.com/services/e-store",
      siteName: "Myomnamo",
      locale: "en_IN",
    },

    mainContent:
      "Book your sacred prasad online with Myomnamo and receive divine blessings at home. Choose fr.om famous temples like Tirupati Balaji, Shirdi Sai Baba, and Ayodhya. Select your preferred date, meal time, and the number of coupons needed. Each prasad is prepared with devotion and love, bringing the temple's spiritual essence to your doorstep. Enjoy the taste of tradition and the comfort of god's grace without leaving your home. Order now and feel the divine connection.",
  },

  // Bhakti Puja Kit 
  {
    headerName: "Bhakti Puja kit ",
    Imgabout1: About1,
    Imgabout2: panditBooking,
    tagLine: "Bhakti Kit Details",
    route: "/services/puja-kit",
    serviceBannerImg: LandingPujaKit,
    sectionTitle: "Complete Puja Samagri Kit",
    serviceName: "puja-kit-services",
    howItWorksMainHeading: "Book a Puja Kit Samagri with Myomnamo",
    howItWorks: [
      {
        howItWorksTitle: "Choose Your Subscription",
        howItWorksDesc:
          "Pick a plan that fits you: monthly, quarterly, or yearly and book your puja kit easily online in just a few steps",
      },
      {
        howItWorksTitle: "Personalize & Confirm",
        howItWorksDesc:
          "Share your delivery details and preferences. Receive confirmation, along with a premium wooden box in select plans",
      },
      {
        howItWorksTitle: "Receive & Renew ",
        howItWorksDesc:
          "Get fresh, high-quality samagri delivered to your door. Quarterly and longer plans include monthly ingredient refills for your convenience.",
      },
    ],
    testimonials: [
      {
        Desc: "The puja kit had everything I needed. It was neat and made the puja very easy. Myomnamo thought it through.",
        name: "Laxmi Karale",
        location: "Jalgaon",
      },
      {
        Desc: "Great quality items. Helped me perform all rituals without running to the market.",
        name: "Shrikant Mule",
        location: "Ahilyanagar",
      },
      {
        Desc: "Ordered the kit last minute, but it arrived on time. Very helpful service from Myomnamo.",
        name: "Manasi Gokhale",
        location: "Mumbai",
      },
      {
        Desc: "A complete kit for anyone who wants to do puja at home properly. Thank you Myomnamo.",
        name: "Rahul Pawaskar",
        location: "Ratnagiri",
      },
    ],
    FaqObj: [
      {
        question: " What are the ingredients in the puja kit?",
        answer:
          "Each kit includes all the necessary ingredients for daily or special rituals. Everything is packed to help you perform your puja with ease.",
        color: "#ffa415",
      },
      {
        question: "How often can I get the puja kit delivered?",
        answer:
          "You can choose monthly, quarterly, or yearly delivery. Pick the option that best fits your worship routine.",
        color: "#fc5528",
      },
      {
        question: "Do I need to arrange puja items?",
        answer:
          "No, we provide all sacred samagri. You only need a device (phone/laptop) to join the live session and participate spiritually.",
        color: "#8139e7",
      },
      {
        question: "Are the kits affordable?",
        answer:
          "Yes, the kits are priced to be budget-friendly. You can maintain your spiritual practices without spending too much.",
        color: "#8139e7",
      },
      {
        question: "Can I change my subscription later?",
        answer:
          "Yes, you can change or update your plan anytime. We make it easy to adjust your subscription as per your needs.",
        color: "#8139e7",
      },
    ],
    metaTitle: "Puja Kit Subscription – Monthly, Quarterly, & Annual Plans",
    metaDescription:
      "Order ready-to-use puja kits with all the samagri needed for your rituals. A simple, devotional service that brings tradition to your doorstep.",
    cannonicalLink: "https://www.myomnamo.com/services/puja-kit-services",
    breadcrumbSchema: {
      "@context": "https://schema.org/",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.myomnamo.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Puja Booking",
          item: "https://www.myomnamo.com/services/puja-kit-services",
        },
      ],
    },

    webpageSchema: {
      "@context": "http://schema.org",
      "@type": "WebPage",
      name: "Puja Kit Subscription – Monthly, Quarterly, & Annual Plans",
      url: "https://www.myomnamo.com/services/puja-kit-services",
      description:
        "Order ready-to-use puja kits with all the samagri needed for your rituals. A simple, devotional service that brings tradition to your doorstep.",
      publisher: {
        "@type": "Organization",
        name: "Myomnamo",
      },
    },

    faqSchema: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: " What are the ingredients in the puja kit ?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Each kit includes all the necessary ingredients for daily or special rituals. Everything is packed to help you perform your puja with ease.",
          },
        },
        {
          "@type": "Question",
          name: " How often can I get the puja kit delivered ?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "You can choose monthly, quarterly, or yearly delivery. Pick the option that best fits your worship routine.",
          },
        },
        {
          "@type": "Question",
          name: "Are the kits affordable?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, the kits are priced to be budget-friendly. You can maintain your spiritual practices without spending too much.",
          },
        },
        {
          "@type": "Question",
          name: "Can I change my subscription later?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, you can change or update your plan anytime. We make it easy to adjust your subscription as per your needs.",
          },
        },
      ],
    },
    metaData: {
      title: "Puja Kit Subscription – Monthly, Quarterly, & Annual Plans",
      description:
        "Order ready-to-use puja kits with all the samagri needed for your rituals. A simple, devotional service that brings tradition to your doorstep.",
      image: "https://www.myomnamo.com/assets/images/new/logo.png",
      url: "https://www.myomnamo.com/services/puja-kit-services",
      siteName: "Myomnamo",
      locale: "en_IN",
    },
    mainContent:
      "Get complete puja kits delivered to your doorstep on a monthly, quarterly, or yearly basis at an affordable price. Each kit includes all the necessary items you need for your daily or special rituals, saving you time and effort. Stay connected to your traditions with easy and convenient subscriptions that suit your needs. Trust Myomnamo to make your puja simple and stress-free, so you can focus on your devotion with peace of mind.",
  },
]


export const landingPageMarathiContent =
  [
    // Remedy Puja
    {
      "headerName": "ऑनलाइन उपचार पूजा बुक करा",
      "tagLine": "दैवी आशीर्वाद प्राप्त करा",
      "route": "/remedy-puja",
      "serviceBannerImg": PujaBookingBannerImg,
      "sectionTitle": "शांती अनुभवण्यासाठी उपचार पूजा बुक करा",
      "serviceName": "remedy-puja",
      "howItWorksMainHeading": "उपाय पूजा आशीर्वाद मिळविण्यासाठी सोप्या पायऱ्या",
      "howItWorks": [
        {
          "howItWorksTitle": "आपली उपचार पूजा निवडा",
          "howItWorksDesc": "आपण ज्या उपचार पूजेला पार पाडू इच्छिता ती निवडा- आरोग्य, करिअर, नातेसंबंध, शांती किंवा एकंदर आध्यात्मिक संतुलनासाठी."
        },
        {
          "howItWorksTitle": "तुमची पूजा बुक करा",
          "howItWorksDesc": "आमचे अनुभवी पंडित प्रत्येक उपचार पूजा भक्तीने पार पाडतात आणि खऱ्या वैदिक पद्धतींचे पालन करतात, जेणेकरून सकारात्मक ऊर्जा मिळतील."
        },
        {
          "howItWorksTitle": "दैवी आरोग्य अनुभवा",
          "howItWorksDesc": "पवित्र ऊर्जा अनुभव करा, दैवी शक्तीशी संपर्क साधा आणि आपल्या जीवनात आरोग्य, आनंद, समृद्धी आणि आध्यात्मिक कल्याणासाठी आशीर्वाद आमंत्रित करा."
        }
      ],
      "testimonials": [
        {
          "Desc": "मी सत्यनारायण पूजा Myomnamo द्वारे बुक केली आणि सर्व काही सुंदररीत्या पार पडले. पंडित विद्वान होते आणि पूजेला पूर्ण भक्तिभावाने पार पाडले. अत्यंत शिफारसीय.",
          "name": "राजेश सिंह",
          "location": "दिल्ली"
        },
        {
          "Desc": "माझी गृहप्रवेश पूजा सुंदररीत्या पार पडली. पंडित वेळेवर आले आणि सर्व साहित्य आणले. खूप छान अनुभव.",
          "name": "प्रिया माने",
          "location": "नाशिक"
        },
        {
          "Desc": "मी नवग्रह शांती पूजा केली आणि Myomnamo मुळे ते खूप सोपे झाले! मंत्रोच्चार आणि विधी उत्तम झाले.",
          "name": "अमित कपूर",
          "location": "मुंबई"
        },
        {
          "Desc": "माझ्या घरी नवरात्रीत पूजा करण्यासाठी Myomnamo ने मदत केली. संपूर्ण प्रक्रिया सुरळीत पार पडली.",
          "name": "राजेश कुलकर्णी",
          "location": "नाशिक"
        }
      ],
      "FaqObj": [
        {
          "question": "मी माझी उपचार पूजा सानुकूलित करू शकतो का?",
          "answer": "हो, आमचे पंडित आपल्या गरजा आणि उद्दिष्टांनुसार पूजा वैयक्तिकृत करतात.",
          "color": "#ffa415"
        },
        {
          "question": "पूजा किती लवकर ठरवता येईल?",
          "answer": "पंडितांच्या उपलब्धतेनुसार पूजा त्वरित ठरवता येऊ शकतात.",
          "color": "#fc5528"
        },
        {
          "question": "आपल्याला प्रसाद मिळेल का?",
          "answer": "हो, पूजे नंतर प्रसाद पाठवला जातो.",
          "color": "#8139e7"
        },
        {
          "question": "मी लाईव्ह उपस्थित राहू शकत नसल्यास काय होईल?",
          "answer": "काही हरकत नाही! आपण पूजेचे व्हिडिओ रेकॉर्डिंग आणि फोटो मिळवाल.",
          "color": "#8139e7"
        },
        {
          "question": "पूजा घरात किंवा मंदिरात करता येईल का?",
          "answer": "हो, आमचे पंडित घरी, मंदिरात किंवा ऑनलाइन पूर्ण भक्तीभावाने आणि योग्य वैदिक विधींनी उपाय पूजा करतात.",
          "color": "#8139e7"
        }
      ],
      "whychooseUs": [
        {
          title: 'शुद्ध वैदिक विधी',
          description: 'अनुभवी पंडित भक्तीने प्रत्येक पूजा पार पाडतात, जे दैवी आशीर्वाद घेण्यासाठी केले जाते.'
        },
        {
          title: 'सोपे पूजा बुकिंग',
          description: 'आपली उपचार पूजा घरून काही सोप्या पावलांत निवडा आणि बुक करा.'
        },
        {
          title: 'लाईव्हमध्ये सहभागी व्हा किंवा रेकॉर्डिंग मिळवा',
          description: 'पवित्र ऊर्जा ऑनलाइन अनुभव करा किंवा पूजेचे व्हिडिओ आणि फोटो मिळवा.'
        },
        {
          title: 'सर्व पूजा साहित्य उपलब्ध',
          description: 'आपल्याला आवश्यक सर्व साहित्य समाविष्ट आहे, जेणेकरून आपण प्रार्थनेवर लक्ष केंद्रीत करू शकता.'
        },
        {
          title: 'स्पष्ट व योग्य किंमत',
          description: 'कोणतीही लपलेली फी नाही, फक्त शुद्ध आणि चिंता-मुक्त आध्यात्मिक अनुभव.'
        },
        {
          title: 'मार्गदर्शन आणि मदत',
          description: 'आमचा संघ नेहमी आपल्या पूजा संबंधित प्रश्नांसाठी तयार आहे.'
        }
      ],
      "whychooseUsTitle": 'भक्तांना आमच्या उपचार पूजेवर का विश्वास आहे?',
      "metaTitle": "ऑनलाइन पूजा बुक करा - सर्व समारंभांसाठी अनुभवी पंडित",
      "metaDescription": "लग्न, गृहप्रवेश किंवा कोणत्याही पूजेसाठी पंडित बुक करा. पूजेला भक्तिभाव आणि परंपरेनुसार पार पाडा.",
      "mainContent": "तुमचे खास क्षण अनुभवी पंडितांच्या मार्गदर्शनाखाली पवित्र करा. लहान घरगुती विधींपासून मोठ्या समारंभापर्यंत, आम्ही श्रद्धा आणि सकारात्मकता तुमच्यापर्यंत आणतो.",
      "metaData": {
        "title": "ऑनलाइन पूजा बुक करा - सर्व समारंभांसाठी अनुभवी पंडित",
        "description": "लग्न, गृहप्रवेश किंवा कोणत्याही पूजेसाठी पंडित बुक करा. पवित्र विधी भक्तिभाव, काळजी आणि परंपरेनुसार पार पाडा. आत्ताच तुमचं बुकिंग सुरू करा!",
        "image": "https://www.myomnamo.com/assets/images/new/logo.png",
        "url": "https://www.myomnamo.com/services/puja-booking",
        "siteName": "Myomnamo",
        "locale": "mr_IN"
      },
      "mainContent": "तुमचे खास क्षण अनुभवी पंडितांच्या मार्गदर्शनाखाली पवित्र करा. लग्न, गृहप्रवेश, नामकरण सोहळा किंवा कोणतीही पूजा असो, पंडित प्रत्येक विधी श्रद्धा व भक्तिभावाने करतात. परंपरेचे ज्ञान तुमच्या घराला किंवा कार्यक्रमाला शांती आणि सकारात्मकता प्रदान करते. लहान घरगुती समारंभ असो किंवा भव्य कार्यक्रम, आम्ही तुमच्या सोहळ्यात श्रद्धा आणि परंपरेचा संगम आणतो. पूजाविधीमुळे तुम्ही तुमच्या श्रद्धेशी जोडले जाता आणि आरोग्य, आनंद व समृद्धीचे आशीर्वाद मिळवता. प्रत्येक सोहळा खास आणि संस्मरणीय बनवा, अनुभवी पंडितांच्या मार्गदर्शनाखाली."
    },
    // Homam Puja
    {
      "headerName": "होमम पूजा सेवा बुक करा",
      "tagLine": "होमम पूजेद्वारे दैवी उपस्थिती अनुभव करा",
      "route": "/homam-puja",
      "serviceBannerImg": PujaBookingBannerImg,
      "sectionTitle": "प्रत्येक संधीसाठी दैवी होमम पूजा ऑनलाइन बुक करा",
      "serviceName": "homam-puja",

      "howItWorksMainHeading": "दैवी आशीर्वादाकडे सुलभ मार्ग",
      "whychooseUsTitle": 'आमच्या होमम पूजेची खासियत काय आहे?',
      "howItWorks": [
        {
          "howItWorksTitle": "आपली होमम पूजा निवडा",
          "howItWorksDesc": "आपल्याला हवी असलेली होमम पूजा निवडा शांती, समृद्धी, आरोग्य, गृहप्रवेश किंवा कोणत्याही खास प्रसंगी."
        },
        {
          "howItWorksTitle": "आपली पूजा सहज बुक करा",
          "howItWorksDesc": "फक्त आपली पूजा बुक करा, आमचे अनुभवी पुजारी प्रत्येक विधी भक्तीपूर्वक आणि खऱ्या वेदिक परंपरेनुसार पार पाडतील."
        },
        {
          "howItWorksTitle": "दैवी आशीर्वाद प्राप्त करा",
          "howItWorksDesc": "पवित्र विधीत सामील व्हा, सकारात्मक ऊर्जा अनुभव घ्या आणि आरोग्य, आनंद आणि समृद्धीचे आशीर्वाद आपल्या जीवनात आमंत्रित करा."
        }
      ],
      "testimonials": [
        {
          "Desc": "मी सत्यनारायण पूजा Myomnamo द्वारे बुक केली आणि सर्व काही सुंदररीत्या पार पडले.",
          "name": "राजेश सिंह",
          "location": "दिल्ली"
        },
        {
          "Desc": "गृहप्रवेश पूजा सुंदररीत्या पार पडली. पंडित वेळेवर आले.",
          "name": "प्रिया माने",
          "location": "नाशिक"
        },
        {
          "Desc": "मी नवग्रह शांती पूजा केली आणि Myomnamo मुळे ते खूप सोपे झाले!",
          "name": "अमित कपूर",
          "location": "मुंबई"
        },
        {
          "Desc": "नवरात्रीत पूजा करण्यासाठी Myomnamo ने मदत केली.",
          "name": "राजेश कुलकर्णी",
          "location": "नाशिक"
        }
      ],
      "FaqObj": [
        {
          "question": "होमम पूजेची बुकिंग किती लवकर करता येईल?",
          "answer": "बहुतेक होमम पूजांसाठी पुजार्‍यांच्या उपलब्धतेनुसार काही तासांत बुकिंग करता येते.",
          "color": "#ffa415"
        },
        {
          "question": "मला मार्गदर्शन किंवा सूचना मिळतील का?",
          "answer": "हो, होमम पूजेसाठी विधीपूर्वी सर्व तपशीलवार सूचना दिल्या जातात.",
          "color": "#fc5528"
        },
        {
          "question": "मी लाईव्ह पाहू शकतो का किंवा रेकॉर्डिंग बघू शकतो?",
          "answer": "हो, आपण लाईव्हमध्ये सामील होऊ शकता किंवा पूजेनंतर व्हिडिओ व फोटो बघू शकता.",
          "color": "#8139e7"
        },
        {
          "question": "होमम पूजा घरात करता येईल का?",
          "answer": "हो, आमचे पुजारी भक्तीपूर्वक घर किंवा मंदिरात विधी पार पाडतात.",
          "color": "#8139e7"
        },
        {
          "question": "ऑनलाइन बुकिंग सुरक्षित आहे का?",
          "answer": "हो, आमचा प्लॅटफॉर्म सुरक्षित आहे आणि सुरळीत बुकिंग प्रक्रिया सुनिश्चित करतो.",
          "color": "#8139e7"
        }
      ],
      "whychooseUs": [
        {
          title: 'सुलभ ऑनलाइन बुकिंग',
          description: 'कोणत्याही खास प्रसंगी आपल्या होमम पूजेची फक्त काही मिनिटांत ऑनलाइन बुकिंग करा.'
        },
        {
          title: 'अनुभवी पंडित',
          description: 'कुशल पंडित घरी, मंदिरात किंवा लाईव्ह स्ट्रीमिंगद्वारे प्रत्येक विधी भक्तीने करतात.'
        },
        {
          title: 'तुमची होमम पूजा निवडा',
          description: 'समृद्धी, आरोग्य आणि यशासाठी गणपती, महा मृत्युञ्जय, नवग्रह, धन्वंतरि, लक्ष्मी, कुबेर, वास्तु होमम निवडा.'
        },
        {
          title: 'सानुकूलित प्रार्थना',
          description: 'आपले नाव आणि कुटुंबाची माहिती विधीत समाविष्ट करा, ज्यामुळे विधी अर्थपूर्ण बनेल.'
        },
        {
          title: 'लाईव्ह आणि रेकॉर्डिंग पर्याय',
          description: 'होमम लाईव्ह पहा किंवा विधीचे व्हिडिओ आणि फोटो नंतर अनुभवण्यासाठी मिळवा.'
        },
        {
          title: 'पूर्ण मार्गदर्शन',
          description: 'स्पष्ट सूचना आणि पूजापूर्व मार्गदर्शन मिळवा, जेणेकरून आपल्याला सर्वकाही ठाऊक असेल.'
        }
      ],
      "metaTitle": "ऑनलाइन पूजा बुक करा - सर्व समारंभांसाठी अनुभवी पंडित",
      "metaDescription": "लग्न, गृहप्रवेश किंवा कोणत्याही पूजेसाठी पंडित बुक करा. पूजेला भक्तिभाव आणि परंपरेनुसार पार पाडा.",
      "mainContent": "तुमचे खास क्षण अनुभवी पंडितांच्या मार्गदर्शनाखाली पवित्र करा. लहान घरगुती विधींपासून मोठ्या समारंभापर्यंत, आम्ही श्रद्धा आणि सकारात्मकता तुमच्यापर्यंत आणतो.",
      "metaData": {
        "title": "ऑनलाइन पूजा बुक करा - सर्व समारंभांसाठी अनुभवी पंडित",
        "description": "लग्न, गृहप्रवेश किंवा कोणत्याही पूजेसाठी पंडित बुक करा. पवित्र विधी भक्तिभाव, काळजी आणि परंपरेनुसार पार पाडा. आत्ताच तुमचं बुकिंग सुरू करा!",
        "image": "https://www.myomnamo.com/assets/images/new/logo.png",
        "url": "https://www.myomnamo.com/services/puja-booking",
        "siteName": "Myomnamo",
        "locale": "mr_IN"
      },
      "mainContent": "कुशल पंडितांद्वारे पार पडणाऱ्या प्रभावी उपचार पूजांचा अनुभव घ्या, जे आपल्या जीवनात शांती, समृद्धी आणि आध्यात्मिक आरोग्य आणतात. हे पारंपरिक वैदिक विधी अडथळे दूर करतात, ऊर्जा संतुलित करतात आणि एकंदर कल्याणाला चालना देतात. आता आपण सहजपणे आपल्या घरातून किंवा कार्यस्थळातून उपचार पूजा ऑनलाइन बुक करू शकता आणि प्रत्येक विधी खऱ्या प्राचीन परंपरेनुसार पार पडतो, जेणेकरून आपण दैवी आशीर्वाद प्राप्त करू शकता."
    },
    // Pandit Booking
    {
      headerName: "पंडित बुकिंग सेवा",
      Imgabout1: About1,
      Imgabout2: panditBooking,
      tagLine: "मंदिर पूजांसह दैवीत्वाचा अनुभव घ्या",
      route: "/services/book-puja",
      serviceBannerImg: PujaBookingBannerImg,
      sectionTitle: "आपल्या पूजेसाठी अनुभवी पंडित बुक करा",
      serviceName: "pandit-booking",
      howItWorksMainHeading: "दैवी आशीर्वादाकडे सहज वाटचाल",
      howItWorks: [
        {
          howItWorksTitle: "आपला सोहळा निवडा",
          howItWorksDesc:
            "लग्न, गृहप्रवेश, नामकरण किंवा कोणतीही विशेष पूजा – तुम्हाला हवी ती निवडा.",
        },
        {
          howItWorksTitle: "आपली पूजा बुक करा",
          howItWorksDesc:
            "आमचे अनुभवी पंडित प्रत्येक विधी श्रद्धेने, भक्तीने आणि वेदशास्त्रानुसार पार पाडतात.",
        },
        {
          howItWorksTitle: "पवित्र वातावरणाचा अनुभव घ्या",
          howItWorksDesc:
            "पंडितजी काळजीपूर्वक तुमचा सोहळा पार पाडतात. दैवी ऊर्जा अनुभवा, श्रद्धेशी नाते जोडा आणि आरोग्य, सुख व समृद्धीचे आशीर्वाद मिळवा.",
        },
      ],
      testimonials: [
        {
          Desc: "मी सत्यानारायण पूजा Myomnamo द्वारे बुक केली होती आणि सर्व व्यवस्था उत्तम प्रकारे करण्यात आल्या. पंडित ज्ञानी, वेळेवर आणि भक्तिभावाने विधी करणारे होते. खूपच समाधानकारक अनुभव.",
          name: "राजेश सिंह",
          location: "दिल्ली",
        },
        {
          Desc: "माझा गृहप्रवेश सोहळा अतिशय सुंदर झाला. पंडित वेळेवर आले आणि सर्व पूजासामग्रीसोबत आले. संपूर्ण प्रक्रिया अत्यंत सुरळीत आणि मंगलमय होती. धन्यवाद, Myomnamo.",
          name: "प्रिया माने",
          location: "नाशिक",
        },
        {
          Desc: "मला नवग्रह शांती पूजा हवी होती आणि Myomnamo मुळे ती खूप सोपी झाली! मंत्रोच्चार, विधी आणि व्यवस्था सर्व उत्तम रीतीने पार पडले. हा खरा दैवी अनुभव होता.",
          name: "अमित कपूर",
          location: "मुंबई",
        },
        {
          Desc: "नवरात्रीत मी माझ्या घरी पूजा आयोजित केली आणि Myomnamo ने सर्व सोय केली. संपूर्ण प्रक्रिया सोपी होती आणि पंडितांनी सर्व विधी शास्त्रशुद्ध केले.",
          name: "राजेश कुलकर्णी",
          location: "नाशिक",
        },
      ],
      FaqObj: [
        {
          question: "मी कोणकोणत्या पूजेसाठी बुकिंग करू शकतो?",
          answer:
            "तुम्ही गणपती पूजा, नवरात्री आरती, लक्ष्मी पूजा आणि इतर अनेक विधी बुक करू शकता.",
          color: "#ffa415",
        },
        {
          question: "मी वारंवार पूजेसाठी बुकिंग करू शकतो का?",
          answer:
            "नक्कीच! तुम्ही दैनंदिन, साप्ताहिक किंवा अनेक दिवस चालणाऱ्या पूजेसाठी बुक करू शकता.",
          color: "#fc5528",
        },
        {
          question: "पंडित अनुभवी आणि पात्र आहेत का?",
          answer:
            "होय, आमचे सर्व पंडित अनुभवी, प्रशिक्षित असून योग्य वेदपरंपरेनुसार विधी करतात.",
          color: "#8139e7",
        },
        {
          question: "मी मंदिरात किंवा घरी पूजा बुक करू शकतो का?",
          answer:
            "होय, तुम्ही घरी, मंदिरात किंवा इच्छित ठिकाणी पूजेचे बुकिंग करू शकता.",
          color: "#8139e7",
        },
        {
          question: "तुम्ही ऑनलाइन पूजेची सुविधा देता का?",
          answer:
            "होय, आम्ही ऑनलाइन पूजा देखील करतो जिथे पंडित विधी आभासी पद्धतीने करतात.",
          color: "#8139e7",
        },
      ],
      metaTitle: "ऑनलाइन पूजा बुक करा - सर्व विधीसाठी अनुभवी पंडित",
      metaDescription:
        "लग्न, गृहप्रवेश किंवा कोणत्याही पूजेसाठी पंडित बुक करा. पूजेचे विधी श्रद्धा, भक्ती आणि परंपरेनुसार पार पाडले जातील. आजच आपले बुकिंग सुरू करा!",
      cannonicalLink: "https://www.myomnamo.com/services/puja-booking",
      breadcrumbSchema: {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "मुख्यपृष्ठ",
            item: "https://www.myomnamo.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "पूजा बुकिंग",
            item: "https://www.myomnamo.com/services/puja-booking",
          },
        ],
      },

      webpageSchema: {
        "@context": "http://schema.org",
        "@type": "WebPage",
        name: "ऑनलाइन पूजा बुक करा - सर्व विधीसाठी अनुभवी पंडित",
        url: "https://www.myomnamo.com/services/puja-booking",
        description:
          "लग्न, गृहप्रवेश किंवा कोणत्याही पूजेसाठी पंडित बुक करा. पूजेचे विधी श्रद्धा, भक्ती आणि परंपरेनुसार पार पाडले जातील. आजच आपले बुकिंग सुरू करा!",
        publisher: {
          "@type": "Organization",
          name: "Myomnamo",
        },
      },

      faqSchema: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "मी कोणकोणत्या पूजेसाठी बुकिंग करू शकतो?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "तुम्ही गणपती पूजा, नवरात्री आरती, लक्ष्मी पूजा आणि इतर अनेक विधी बुक करू शकता.",
            },
          },
          {
            "@type": "Question",
            name: "मी वारंवार पूजेसाठी बुकिंग करू शकतो का?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "नक्कीच! तुम्ही दैनंदिन, साप्ताहिक किंवा अनेक दिवस चालणाऱ्या पूजेसाठी बुक करू शकता.",
            },
          },
          {
            "@type": "Question",
            name: "पंडित अनुभवी आणि पात्र आहेत का?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "होय, आमचे सर्व पंडित अनुभवी, प्रशिक्षित असून योग्य वेदपरंपरेनुसार विधी करतात.",
            },
          },
          {
            "@type": "Question",
            name: "मी मंदिरात किंवा घरी पूजा बुक करू शकतो का?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "होय, तुम्ही घरी, मंदिरात किंवा इच्छित ठिकाणी पूजेचे बुकिंग करू शकता.",
            },
          },
          {
            "@type": "Question",
            name: "तुम्ही ऑनलाइन पूजेची सुविधा देता का?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "होय, आम्ही ऑनलाइन पूजा देखील करतो जिथे पंडित विधी आभासी पद्धतीने करतात.",
            },
          },
        ],
      },
      metaData: {
        title: "ऑनलाइन पूजा बुक करा - सर्व विधीसाठी अनुभवी पंडित",
        description:
          "लग्न, गृहप्रवेश किंवा कोणत्याही पूजेसाठी पंडित बुक करा. पूजेचे विधी श्रद्धा, भक्ती आणि परंपरेनुसार पार पाडले जातील. आजच आपले बुकिंग सुरू करा!",
        image: "https://www.myomnamo.com/assets/images/new/logo.png",
        url: "https://www.myomnamo.com/services/puja-booking",
        siteName: "Myomnamo",
        locale: "mr_IN",
      },
      mainContent:
        "अनुभवी पंडितांच्या मार्गदर्शनाने तुमचे खास क्षण पवित्र बनवा. मग ते लग्न असो, गृहप्रवेश, नामकरण किंवा कोणतीही पूजा – पंडित प्रत्येक विधी श्रद्धा आणि भक्तीने पार पाडतात. त्यांचे परंपरांचे ज्ञान तुमच्या घरी शांती आणि सकारात्मकता आणते. छोट्या घरगुती सोहळ्यांपासून मोठ्या कार्यक्रमांपर्यंत, आम्ही तुमच्या समारंभात मंगलमय वातावरण निर्माण करतो. पूजेच्या विधींमुळे श्रद्धेशी नाते जोडले जाते आणि आरोग्य, सुख, समृद्धीचे आशीर्वाद लाभतात. अनुभवी पंडिताच्या मार्गदर्शनाने प्रत्येक सोहळा खास आणि संस्मरणीय बनवा.",
    },
    // Daily Pandit Puja
    {
      headerName: "दैनंदिन पूजा बुकिंग सेवा",
      Imgabout1: About1,
      Imgabout2: DailyPooja,
      tagLine: "मंदिरातील  पूजांद्वारे दिव्य प्रचितीचा अनुभव घ्या",
      sectionTitle: "तुमच्या सोयीने रोजच्या पूजेसाठी पुजारी बुक करा",
      serviceBannerImg: DailyPujaBookingBannerImg,
      serviceName: "daily-puja-booking",
      howItWorksMainHeading: "तुमच्या सोयीने रोजच्या पूजेसाठी पंडित बुक करा",
      howItWorks: [
        {
          howItWorksTitle: "तुमचा विधी निवडा",
          howItWorksDesc:
            "गणपती पूजा असो, नवरात्रीची आरती असो किंवा साधी सकाळची प्रार्थना — तुम्हाला हवी असलेली सेवा निवडा. आम्ही तुम्हाला अनुभवी पुरोहितासोबत जोडून देऊ.",
        },
        {
          howItWorksTitle: "तुमचा वेळ ठरवा",
          howItWorksDesc:
            "तुमच्या वेळेनुसार दिनांक आणि वेळ निवडा. पंडित सकाळी आणि संध्याकाळी उपलब्ध असतात, त्यामुळे तुम्ही तुमच्या सोयीने विधी ठरवू शकता.",
        },
        {
          howItWorksTitle: "दिव्य आशिर्वाद अनुभव करा",
          howItWorksDesc:
            "तुम्ही ठरवलेला पंडित पूजेसाठी आवश्यक सर्व वस्तू घेऊन येतो. पूजा द्वारे तुमच्या घरात शांतता, सकारात्मकता आणि दिव्य ऊर्जा मिळवा.",
        },
      ],
      "whychooseUs": [
        {
          title: 'अनुभवी पंडित',
          description: 'दैनंदिन पूजा तज्ञ पंडितांद्वारे केली जाते, ज्यांना वेदिक विधींचे सखोल ज्ञान आहे आणि जे खरेपणाची हमी देतात.'
        },
        {
          title: 'सोयीस्कर बुकिंग',
          description: 'दररोजच्या पूजेसाठी आपल्या पसंतीच्या वेळेनुसार सोप्या पद्धतीने  पंडित बुक करा आणि आध्यात्मिक सेवा आपल्या दारी आणा.'
        },
        {
          title: 'तुमच्या गरजेनुसार विधी',
          description: 'प्रत्येक पूजा आम्ही अचूकतेने, आदराने आणि तुमच्या गरजांनुसार करतो, जेणेकरून  तुमच्या गरजा आणि परंपरांचे पालन होईल.'
        },
        {
          title: 'सर्वसमावेशक सेवा',
          description: 'मंत्रोच्चारापासून आरतीपर्यंत, तुमची दररोजची पूजा पारंपरिक आणि अचूक रीत्या केली जाते याची आम्ही पूर्ण काळजी घेतो.'
        },
        {
          title: 'सकारात्मक वातावरण',
          description: 'आमच्या समर्पित आणि भक्तिभावपूर्ण पूजासेवेमुळे आपल्या घरी शांतता, सकारात्मकता  टिकून सुरक्षा कवच लाभण्यास मदतच होते.'
        },
        {
          title: 'विश्वासू मार्गदर्शन',
          description: 'विश्वासू पंडितांच्या मार्गदर्शनाखाली दररोज पूजा करून दिव्य आशिर्वाद अनुभवा आणि अध्यात्माशी तुमच नातं अधिक घट्ट करा.'
        }
      ],
      "whychooseUsTitle": 'माय ओम नमो, सोपी आणि खऱ्या  स्वरूपाची  पूजा सेवा देते, ज्यावर हजारो भाविक विश्वास ठेवत आहेत.',

      testimonials: [
        {
          Desc: "मी दररोजची गणेश पूजा बुक केली आणि त्यामुळे माझ्या घरात खूप सकारात्मकता आली आहे. पंडित भक्तीभावाने पुजा करतात आणि सगळं व्यवस्थित आयोजित केलेलं असतं. मनापासून आभारी आहे.",
          name: "अंजली राजपूत",
          location: "मुंबई",
        },
        {
          Desc: "माझ्या कुटुंबाला दररोज शिव अभिषेक करायचे होते , आणि मायओमनमोने ते सहज शक्य केलं. पंडित वेळेवर येतात, जाणकार आहेत आणि योग्य वैदिक परंपरा पाळतात. अत्यंत प्रशंसनीय.",
          name: "सुरेश काळे",
          location: "नाशिक",
        },
        {
          Desc: "मी मासिक लक्ष्मी पूजेची सेवा घेतली आणि अनुभव खूपच छान होता. प्रार्थना प्रामाणिकपणाने  केली जाते, जे आपल्या घरी शांतता आणि समृद्धी आणते.",
          name: "मीरा सावंत",
          location: "बँगलोर",
        },
        {
          Desc: "कामात व्यस्त असलेल्या लोकांसाठी श्रद्धेशी जोडून राहण्याचा मायओमनमोचा खूप चांगला पर्याय आहे.",
          name: "चेतन पवार",
          location: "चंद्रपूर",
        },
        {
          Desc: "प्रत्येक सकाळी मला पूजेबाबत अपडेट मिळते. यामुळे दिवसाची सुरुवात सकारात्मक होते. मायओमनमोचे मनापासून आभार.",
          name: "अर्जुन शिंदे",
          location: "जळगाव",
        },
      ],
      FaqObj: [
        {
          question: "दैनंदिन पूजा बुकिंग सेवा म्हणजे काय?",
          answer:
            "ही सेवा तुम्हाला घरात किंवा मंदिरात दररोज पूजा करण्यासाठी पंडित बुक करण्याची सुविधा देते.",
          color: "#ffa415",
        },
        {
          question: "मी माझ्या विधीसाठी पंडित कसा बुक करू शकतो?",
          answer:
            "तुमच्या विधीचा प्रकार निवडा, तारीख ठरवा आणि बुकिंगची पुष्टी करून तुम्ही सहजपणे ऑनलाईन पंडित बुक करू शकता.",
          color: "#fc5528",
        },
        {
          question: "मी ठराविक पंडित निवडू शकतो का?",
          answer:
            "होय, तुम्ही उपलब्धतेनुसार आणि तुमच्या आवडत्या भाषेप्रमाणे किंवा परंपरेनुसार पंडित निवडू शकता.",
          color: "#8139e7",
        },
        {
          question: "मी दररोज ठराविक वेळेत पूजा ठरवू शकतो का?",
          answer:
            "होय, तुम्ही तुमच्या सोयीप्रमाणे दररोज पूजेचा ठराविक वेळ ठरवू शकता.",
          color: "#8139e7",
        },
        {
          question: "मी व्हर्चुअल दैनंदिन पूजा बुक करू शकतो का?",
          answer:
            "होय, आम्ही ऑनलाइन पूजा सेवा देतो जिथे पंडित विधी पार पाडतात.",
          color: "#8139e7",
        },
      ],
      route: "/daily-pandit-puja",
      metaTitle:
        "दैनंदिन पूजा बुकिंग ऑनलाइन - सकाळ व संध्याकाळच्या विधीसाठी विश्वासार्ह पंडित",
      metaDescription:
        "तुमच्या दैनंदिन पूजेसाठी अनुभवी पंडित बुक करा. तुमचा विधी निवडा, वेळ ठरवा आणि घरात सहजपणे दैवी आशीर्वाद आमंत्रित करा. आजच सकाळी किंवा संध्याकाळी बुक करा.",
      cannonicalLink: "https://www.myomnamo.com/services/daily-puja-booking",
      breadcrumbSchema: {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "मुख्यपृष्ठ",
            item: "https://www.myomnamo.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "दैनंदिन पूजा बुकिंग",
            item: "https://www.myomnamo.com/services/daily-puja-booking",
          },
        ],
      },
      webpageSchema: {
        "@context": "http://schema.org",
        "@type": "WebPage",
        name: "दैनंदिन पूजा बुकिंग ऑनलाइन - सकाळ व संध्याकाळच्या विधीसाठी विश्वासार्ह पंडित",
        url: "https://www.myomnamo.com/services/daily-puja-booking",
        description:
          "तुमच्या दैनंदिन पूजेसाठी अनुभवी पंडित बुक करा. तुमचा विधी निवडा, वेळ ठरवा आणि घरात सहजपणे दैवी आशीर्वाद आमंत्रित करा. आजच सकाळी किंवा संध्याकाळी बुक करा.",
        publisher: {
          "@type": "Organization",
          name: "Myomnamo",
        },
      },
      faqSchema: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "दैनंदिन पूजा बुकिंग सेवा म्हणजे काय?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "यामुळे तुम्ही घरात किंवा मंदिरात दैनंदिन पूजेसाठी पंडित बुक करू शकता.",
            },
          },
          {
            "@type": "Question",
            name: "मी माझ्या विधीसाठी पंडित कसा बुक करू?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "तुम्ही सहजपणे ऑनलाइन पंडित बुक करू शकता – तुमचा विधी निवडा, तारीख ठरवा आणि बुकिंग कन्फर्म करा.",
            },
          },
          {
            "@type": "Question",
            name: "मी विशिष्ट पंडित निवडू शकतो का?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "होय, उपलब्धतेनुसार आणि तुमच्या पसंतीच्या भाषेनुसार किंवा परंपरेनुसार पंडित निवडू शकता.",
            },
          },
          {
            "@type": "Question",
            name: "मी रोज ठराविक वेळी पूजा ठरवू शकतो का?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "होय, तुम्ही तुमच्या सोयीप्रमाणे रोज ठराविक वेळी पूजा आयोजित करू शकता.",
            },
          },
          {
            "@type": "Question",
            name: "मी व्हर्च्युअल दैनंदिन पूजा बुक करू शकतो का?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "होय, आम्ही ऑनलाइन पूजांची सुविधा देतो जिथे पंडित विधी आभासी पद्धतीने करतात.",
            },
          },
        ],
      },
      metaData: {
        title:
          "दैनंदिन पूजा बुकिंग ऑनलाइन - सकाळ व संध्याकाळच्या विधीसाठी विश्वासार्ह पंडित",
        description:
          "तुमच्या दैनंदिन पूजेसाठी अनुभवी पंडित बुक करा. तुमचा विधी निवडा, वेळ ठरवा आणि घरात सहजपणे दैवी आशीर्वाद आमंत्रित करा. आजच सकाळी किंवा संध्याकाळी बुक करा.",
        image: "https://www.myomnamo.com/assets/images/new/logo.png",
        url: "https://www.myomnamo.com/services/daily-puja-booking",
        siteName: "Myomnamo",
        locale: "mr_IN",
      },
      mainContent:
        "दररोज घरच्या पूजेसाठी किंवा आपल्या कार्यक्रमासाठी पुरोहित हवे आहेत  का? अनुभवी  पुरोहित दररोज सकाळी आणि संध्याकाळी उपलब्ध आहेत, जे तुमच्या धार्मिक अनुभवास भक्तीभावाने आणि काळजीपूर्वक मार्गदर्शन करतील.१० दिवसांची गणपती पूजा असो, नवरात्रीची आरती असो किंवा कोणताही बहुदिवसीय विधी असो, आम्ही प्रत्येक विधी पारंपरिक पद्धतीने आणि अचूकतेने पार पाडतो. मंत्रोच्चारापासून आरतीपर्यंत सर्व विधी योग्य रीत्या पार पाडले जातात. अनुभवी आणि विश्वासार्ह पंडितांच्या मार्गदर्शनाने आपल्या पूजेला एक नवे आध्यात्मिक रूप द्या.दररोज आपल्या घरात शांतता, सकारात्मकता आणि दिव्य आशिर्वाद मिळवा.",
    },

    // Prasad Booking 
    {
      headerName: "ऑनलाइन प्रसाद बुकिंग सेवा",
      Imgabout1: About1,
      Imgabout2: Ecart,
      tagLine: "पवित्र मंदिर प्रसादाचा अनुभव घ्या",
      serviceBannerImg: prasadBooking,
      route: "/temple",
      serviceName: "online-prasad-booking",
      howItWorksMainHeading: "Myomnamo द्वारे प्रसाद ऑनलाइन बुक करा",
      howItWorks: [
        {
          howItWorksTitle: "आपल्या पसंतीनुसार निवडा",
          howItWorksDesc:
            "आपला आवडता प्रसाद, जेवणाची वेळ आणि संख्येची निवड करा. श्रद्धेने तयार केलेल्या प्रसादांच्या विविध पर्यायांमधून निवडा.",
        },
        {
          howItWorksTitle: "बुक करा आणि पेमेंट करा",
          howItWorksDesc:
            "केवळ काही क्लिकमध्ये आपले बुकिंग पूर्ण करा. सुरक्षित पेमेंट पर्यायांसह त्रासमुक्त सेवा अनुभवा.",
        },
        {
          howItWorksTitle: "प्रसाद मिळवा आणि आशिर्वाद अनुभवा",
          howItWorksDesc:
            "दिव्य प्रसाद आपल्या घरी पोहोचवा. पवित्र प्रसादाचा आस्वाद घ्या आणि देवाच्या आशिर्वादांची अनुभूती घ्या.",
        },
      ],
      "whychooseUs": [
        {
          title: 'देवाचे आशीर्वाद थेट आपल्या घरी',
          description: 'प्रसिद्ध मंदिरांमधून पवित्र प्रसाद प्राप्त करा, जे मंदिराची आध्यात्मिक ऊर्जा आणि देवाचे आशिर्वाद थेट तुमच्या दारापर्यंत आणतात.'
        },
        {
          title: 'परंपरेची एक अनोखा आध्यात्मिक अनुभव घेण्यासाठी',
          description: 'भक्तीभावाने आणि शुद्ध साहित्याने तयार केलेला पारंपरिक प्रसाद अनुभववा.'
        },
        {
          title: 'सुलभ आणि सोपे',
          description: 'आपली आवडती तारीख, जेवणाचा वेळ आणि प्रमाण निवडा, आणि घरबसल्या दिव्य प्रसाद मिळवा.'
        },
        {
          title: 'भक्तीभावाने तयार केलेले',
          description: 'प्रत्येक प्रसाद श्रद्धेने आणि काळजीने तयार केला जातो, ज्यामुळे तुम्हाला निवडलेल्या मंदिराचा पवित्र आणि आशिर्वादित प्रसाद घरपोच तुम्हाला मिळतो.'
        },
        {
          title: 'देवत्वाशी जोडा',
          description: 'आध्यात्मिक नाते मजबूत करा आणि आशीर्वादित प्रसादाच्या पवित्र चवेमुळे देवाच्या कृपेचा सुखद अनुभव घ्या.'
        },
        {
          title: 'त्रासमुक्त अनुभव',
          description: 'प्रवास आणि लांब रांगा टाळा; फक्त काही क्लिकमध्ये आपला प्रसाद ऑनलाइन बुक करा आणि सोपी व समाधानी सेवेचा अनुभव घ्या.'
        }
      ],
      "whychooseUsTitle": 'माय ओम नमो, सोपी आणि खऱ्या  स्वरूपाची  पूजा सेवा देते, ज्यावर हजारो भाविक विश्वास ठेवत आहेत.',
      testimonials: [
        {
          Desc: " मी लक्ष्मीची मूर्ती आणि रुद्राक्ष माळा ऑर्डर केली, आणि त्यांची गुणवत्ता अप्रतिम होती. वस्तू व्यवस्थित पॅक करून वेळेवर पोहोचवल्या. खूप समाधानी झाले.",
          name: "पूजा मोरे",
          location: "पुणे",
        },
        {
          Desc: "मी पूर्ण पूजा किट विकत घेतले आणि त्यामुळे माझ्या विधी अतिशय सोप्या झाल्या. सगळं सामान प्रामाणिक आणि आध्यात्मिकदृष्ट्या आशीर्वादित होतं. मी नक्कीच शिफारस करेन.",
          name: "विकास राठी",
          location: "बँगलोर",

        },
        {
          Desc: "मी ई-स्टोअरमधून अगरबत्ती आणि शंख खरेदी केले. डिलिव्हरी वेगवान होती आणि पॅकिंग उत्तम होतं. पुन्हा नक्की खरेदी करेल.",
          name: "मीनल शिंदे",
          location: "जयपूर",
        },
        {
          Desc: "मी मंदिरात जाऊ शकलो नाही, पण प्रसाद मिळाल्यामुळे मला सहभागी झाल्यासारखं वाटलं. Myomnamo चांगलं काम करत आहे.",
          name: "नितीन कोरडे",
          location: "पुणे",
        },
      ],
      FaqObj: [
        {
          question: "मी कोणकोणत्या मंदिरांचा प्रसाद बुक करू शकतो?",
          answer:
            "तुम्ही तिरुपती बालाजी, शिर्डी साईबाबा, अयोध्या राम मंदिर यांसारख्या प्रसिद्ध मंदिरांचा पारंपरिक भक्तीभावाने तयार केलेला प्रसाद बुक करू शकता.",
          color: "#ffa415",
        },
        {
          question: "डिलिव्हरीमध्ये किती वेळ लागतो?",
          answer:
            "डिलिव्हरीचा वेळ ठिकाणानुसार बदलतो, पण आमचा प्रयत्न असतो की तुम्हाला प्रसाद ताजा आणि सुरक्षित पोहोचवायचा. सामान्यतः, बुकिंगनंतर ३ ते ७ कामकाजी दिवसांत डिलिव्हरी होते.",
          color: "#fc5528",
        },
        {
          question: "प्रसाद स्वच्छतेने तयार होतो का?",
          answer:
            "होय, सर्व प्रसाद मंदिराच्या मान्यताप्राप्त स्वयंपाकघरात खूप स्वच्छता आणि पारंपरिक पद्धतींचे पालन करून तयार होतो, ज्यामुळे प्रसाद शुद्ध आणि पवित्र राहतो.",
          color: "#8139e7",
        },
        {
          question: "मी खास प्रसंगी प्रसाद बुक करू शकतो का?",
          answer:
            "नक्कीच! तुम्ही सण, पूजा किंवा कौटुंबिक समारंभांसाठी मोठ्या प्रमाणात प्रसाद बुक करू शकता आणि आपल्या प्रियजनांशी दिव्य आशीर्वाद शेअर करू शकता.",
          color: "#8139e7",
        },
      ],
      sectionTitle: "ऑनलाइन प्रसाद बुकिंग सेवा",
      metaTitle: "Online Prasad Booking - Receive Divine Blessings at Home",
      metaDescription:
        "Book authentic temple prasad online and enjoy sacred blessings at home. Select your meal time and quantity for a convenient spiritual experience. Order Now!",
      cannonicalLink: "https://www.myomnamo.com/services/online-prasad-booking",
      breadcrumbSchema: {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",

        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.myomnamo.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Online Prasad Booking",
            item: "https://www.myomnamo.com/services/online-prasad-booking",
          },
        ],
      },
      webpageSchema: {
        "@context": "http://schema.org",
        "@type": "WebPage",
        name: "Online Prasad Booking - Receive Divine Blessings at Home",
        url: "https://www.myomnamo.com/services/online-prasad-booking",
        description:
          "Book authentic temple prasad online and enjoy sacred blessings at home. Select your meal time and quantity for a convenient spiritual experience. Order Now!",
        publisher: {
          "@type": "Organization",
          name: "Myomnamo",
        },
      },
      faqSchema: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "Which temples' prasad can I book?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "You can book prasad from famous temples, including Tirupati Balaji, Shirdi Sai Baba, and Ayodhya Ram Mandir, all prepared with traditional devotion.",
            },
          },
          {
            "@type": "Question",
            name: "How long does delivery take?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Delivery time varies by location, but we ensure your prasad reaches you fresh, typically within 3-7 business days after booking.",
            },
          },
          {
            "@type": "Question",
            name: "Is the prasad prepared hygienically?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, all prasad is prepared in temple-approved kitchens following strict hygiene and traditional methods to maintain purity and sanctity.",
            },
          },
          {
            "@type": "Question",
            name: "Can I book prasad for special occasions?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Absolutely! You can book prasad in bulk for festivals, pujas, or family gatherings and share divine blessings with your loved ones.",
            },
          },
        ],
      },
      metaData: {
        title: "Online Puja Samagri Store - Buy Puja Items at Myomnamo",
        description:
          "Online shopping for authentic Puja samagri and puja items at Myomnamo. Explore a wide range of spiritual products for all your rituals and ceremonies. Fast delivery and trusted quality.",
        image: "https://www.myomnamo.com/assets/images/new/logo.png",
        url: "https://www.myomnamo.com/services/e-store",
        siteName: "Myomnamo",
        locale: "en_IN",
      },

      mainContent:
        "Myomnamo द्वारे आता आपण आपल्यास हवा असलेला पवित्र प्रसाद ऑनलाइन बुक करू शकता आणि घरीच देवाचे आशिर्वाद प्राप्त करू शकता. तिरुपती बालाजी , शिर्डी साईबाबा आणि अयोध्या सारख्या प्रसिद्ध मंदिरांचा प्रसाद निवडा.  आपली इच्छित तारीख, जेवणाची वेळ आणि किती कूपन हवे आहेत हे निवडा. प्रत्येक प्रसाद भक्तीपूर्ण वातावरण व श्रद्धेने तयार केला जातो. परंपरेची चव आणि देवाच्या कृपेचा सुखद अनुभव घरीच मिळवा. आजच ऑर्डर करा आणि देवाशी तुमचा अतूट संबंध अनुभवा.",
    },

    // Horoscope
    {
      headerName: "राशीभविष्य वाचन",
      Imgabout1: About1,
      Imgabout2: Horoscope,
      tagLine: "मंदिरातील पूजांद्वारे देवाशी नातं जोडा",
      route: "/basic-details",
      serviceBannerImg: HoroscopeBannerImg,
      cannonicalLink: "https://www.myomnamo.com/services/horoscope",
      serviceName: "horoscope",
      sectionTitle: "तुमच्या ग्रहांचा संदेश समजून घ्या",
      howItWorksMainHeading: "आमचे राशिभविष्य वाचन कसे काम करते",
      howItWorks: [
        {
          howItWorksTitle: "तुमची राशी निवडा",
          howItWorksDesc:
            "तुमच्या भावना,आयुष्य आणि भविष्याबद्दल खास वाचन मिळवण्यासाठी तुमची राशी निवडा.",
        },
        {
          howItWorksTitle: "त्वरित जाणून घ्या",
          howItWorksDesc:
            "दररोज, आठवड्याचा किंवा वर्षाच राशीभविष्य मिळवा, प्रेम, करिअर आणि आरोग्याबाबत सखोल मार्गदर्शनांसहित.",
        },
        {
          howItWorksTitle: "तुमचा मार्ग स्वीकारा",
          howItWorksDesc:
            "राशीनुसार सल्ला घेऊन निर्णय घ्या, भाग्यवान दिवस ओळखा आणि आयुष्यात अधिक आनंद आणि संतुलन आणा.",
        },
      ],
      "whychooseUsTitle": 'Myomnamo सोपी आणि प्रामाणिक पूजा सेवा देते, ज्यावर हजारो भक्त विश्वास ठेवतात',
      "whychooseUs": [
        {
          title: 'दैनिक राशी',
          description: 'तुमच्या राशीचा दररोजचा अंदाज मिळवा आणि दिवस नीट समजून घ्या.'
        },
        {
          title: 'अचूक भविष्यवाणी',
          description: 'तुमच्या राशीनुसार स्पष्ट आणि अचूक अंदाज मिळवा.'
        },
        {
          title: 'पंचांग माहिती',
          description: 'आपल्या निर्णय आणि विधींसाठी आम्ही सखोल पंचांग माहिती पुरवतो.'
        },
        {
          title: 'वैयक्तिक मार्गदर्शन',
          description: 'अनुभवी ज्योतिषी तुम्हाला जीवनातील आव्हाने आणि संधी ओळखण्याचा  खास सल्ला देतात.'
        },
        {
          title: 'दररोजचा सूर्योदय-सूर्यास्त वेळ',
          description: 'राशीभविष्यासह रोजच्या सूर्योदय आणि सूर्यास्त वेळा जाणून घ्या आणि आध्यात्मिक सुसंवाद ठेवा.'
        },
        {
          title: 'सणांची पूर्वसूचना',
          description: 'आगामी सण आणि शुभ दिवसांची तुम्हाला आधीच सूचना मिळेल.'
        }
      ],
      testimonials: [
        {
          Desc: "माझे करिअर आणि वैयक्तिक आयुष्यातील अनेक गोष्टी समजून घेण्यासाठी मायओमनमो कडून मिळालेला वैयक्तिक राशी अहवाल खूप उपयुक्त ठरला. खूप माहितीपूर्ण आहे.",
          name: "अमित डुंबरे",
          location: "पुणे",
        },
        {
          Desc: "मी आधी ज्योतिषाला फार गांभीर्याने घेत नव्हतो, पण मायओमनमो कडून मिळणारे साप्ताहिक मार्गदर्शन खरंच मला चांगले निर्णय घेण्यास मदत करत आहे .",
          name: "वैशाली ठाकूर",
          location: "नागपूर ",
        },
        {
          Desc: "मी मायओमनमोचा दैनिक राशीभविष्य वाचायला सुरुवात केली आणि दररोज सकाळी मला स्पष्टता आणि लक्ष केंद्रीत होण्याची भावना मिळते. ते खूप अचूक आणि अर्थपूर्ण वाटतंय.",
          name: "प्राची केळकर",
          location: "मुंबई ",
        },
        {
          Desc: "मायओमनमोचं राशीभविष्य वाचन सविस्तर आणि सोपं होतं. फार तांत्रिक नव्हतं आणि मला उपयोगी सल्ले दिले.",
          name: "रोहित पानसरे",
          location: "नाशिक ",
        },
      ],
      FaqObj: [
        {
          question: "मंदिरातील पूजा सेवा म्हणजे काय",
          answer:
            "आमची सेवा तुम्हाला मंदिरातील पूजा ऑनलाइन बुक करण्याची सोय देते, ज्यामुळे तुम्हाला एक सुरळीत आणि तणावमुक्त अनुभव मिळतो.",
          color: "#ffa415",
        },
        {
          question: "मी पूजा कशी बुक करू?",
          answer:
            "तुम्ही ऑनलाइन किंवा मंदिरात बुक करू शकता. पूजा प्रकार, तारीख आणि वेळ निवडा.",
          color: "#fc5528",
        },
        {
          question: "कोणत्या प्रकारच्या पूजांचा पर्याय आहे?",
          answer:
            "आम्ही वाढदिवस, वर्धापनदिन, सण, वैयक्तिक प्रार्थना आणि खास विधींसाठी पूजा सेवा देतो.",
          color: "#8139e7",
        },
        {
          question: "खास किंवा खाजगी पूजा उपलब्ध आहेत का?",
          answer:
            "होय, काही मंदिरांमध्ये वैयक्तिकृत विधींसह खास खाजगी पूजा करता येतात.",
          color: "#8139e7",
        },
      ],
      metaTitle: "Horoscope Readings by Zodiac Sign - Know Your Future",
      metaDescription:
        "Find guidance for love, career, and life decisions with a horoscope reading. Explore daily, weekly, or yearly insights tailored to your zodiac sign. Book a consultation.",
      canonicalLink: "https://www.myomnamo.com/services/horoscope",
      breadcrumbSchema: {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.myomnamo.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Horoscope",
            item: "https://www.myomnamo.com/services/horoscope",
          },
        ],
      },
      webpageSchema: {
        "@context": "http://schema.org",
        "@type": "WebPage",
        name: "Horoscope Readings by Zodiac Sign - Know Your Future",
        url: "https://www.myomnamo.com/services/horoscope",
        description:
          "Find guidance for love, career, and life decisions with a horoscope reading. Explore daily, weekly, or yearly insights tailored to your zodiac sign. Book a consultation.",
        publisher: {
          "@type": "Organization",
          name: "Myomnamo",
        },
      },
      metaData: {
        title: "Horoscope Readings by Zodiac Sign - Know Your Future",
        description:
          "Find guidance for love, career, and life decisions with a horoscope reading. Explore daily, weekly, or yearly insights tailored to your zodiac sign. Book a consultation.",
        image: "https://www.myomnamo.com/assets/images/new/logo.png",
        url: "https://www.myomnamo.com/services/horoscope",
        siteName: "Myomnamo",
        locale: "en_IN",
      },
      mainContent:
        "एक साधे  राशीभविष्य वाचन करून तुमचं भविष्य काय सांगतंय ते जाणून घ्या. आजचा,  आठवड्याचा किंवा वर्षभराचा अंदाज सहज समजून घ्या. प्रेम,  आरोग्य,काम आणि इतर गोष्टींबद्दल उपयुक्त माहिती मिळवा. मोठा निर्णय घ्यायचा असेल किंवा फक्त उत्सुकता असेल, तरीही राशीभविष्य मार्गदर्शन करू शकतं. भाग्यवान दिवस, उपयोगी सल्ले आणि आयुष्यात जास्त आनंद मिळवण्याचे मार्ग शोधा. ज्यांना थोडंसं अधिक स्पष्ट जाणून घ्यायचं आहे आणि शांत आयुष्य हवं आहे, त्यांच्यासाठी हे योग्य आहे. ग्रहांवर विश्वास ठेवा आणि उज्ज्वल भविष्याकडे वाटचाल करा.",
    },

    // Bhakti Puja Kit 
    {
      headerName: "भक्ती पूजा किट",
      Imgabout1: About1,
      Imgabout2: panditBooking,
      tagLine: "भक्ती किट संपूर्ण माहिती",
      route: "/services/puja-kit",
      serviceBannerImg: LandingPujaKit,
      sectionTitle: "संपूर्ण पूजेसाठी साहित्य किट",
      serviceName: "puja-kit-services",
      howItWorksMainHeading: "MyOmnamo सोबत पूजा किट साहित्य बुक करा",
      howItWorks: [
        {
          howItWorksTitle: "तुमची सब्स्क्रिप्शन निवडा",
          howItWorksDesc:
            "मासिक, त्रैमासिक किंवा वार्षिक कोणतीही सब्स्क्रिप्शन  निवडा आणि फक्त काही सोप्या टप्प्यांमध्ये  ऑनलाइन पूजा किट सहज बुक करा.",
        },
        {
          howItWorksTitle: "पसंती  करा आणि पुष्टी करा",
          howItWorksDesc:
            "तुमचे डिलिव्हरी  तपशील आणि पसंती सांगा. पुष्टी मिळवा, आणि निवडक सब्स्क्रिप्शन प्रीमियम लाकडी बॉक्सही मिळवा.",
        },
        {
          howItWorksTitle: "सामग्री मिळवा आणि रिन्यू करा",
          howItWorksDesc:
            "तुमच्या दारात ताजी आणि उच्च प्रतीची पूजेसामग्री पोहोचवा. त्रैमासिक आणि दीर्घकालीन सब्स्क्रिप्शन तुमच्या सोयीसाठी दरमहा साहित्य पुन्हा मिळवून देतात.",
        },
      ],
      testimonials: [
        {
          Desc: "पूजा किटमध्ये मला आवश्यक असलेले सगळे काही होते. ते व्यवस्थित होते आणि त्या मुले पूजा खूप सोपी झाली . MyOmnamo ने खूप विचारपूर्वक बनवले आहे.",
          name: "लक्ष्मी कारले",
          location: "जळगाव",
        },
        {
          Desc: "उत्कृष्ट प्रतीची सामग्री. सगळी पूजाविधी बाजारात न जाता सहज पार पाडता आले. ",
          name: "श्रीकांत मुळे",
          location: "अहिल्यानगर",
        },
        {
          Desc: "शेवटच्या क्षणी किट ऑर्डर केले होते, पण वेळेवर पोहोचले. MyOmnamo ची सेवा खूप उपयुक्त ठरली.",
          name: "मानसी गोखले",
          location: "मुंबई ",
        },
        {
          Desc: "जे कोणी घरी योग्य रितीने पूजा करायची इच्छा ठेवतात, त्यांच्यासाठी हे एक परिपूर्ण किट आहे. धन्यवाद MyOmnamo.",
          name: "राहुल पावसकर",
          location: "रत्नागिरी",
        },
      ],
      FaqObj: [
        {
          question: "मी नंतर माझी सब्स्क्रिप्शन बदलू शकतो का?",
          answer:
            "होय, तुम्ही कधीही तुमची सब्स्क्रिप्शन बदलू किंवा अपडेट करू शकता. तुमच्या गरजेनुसार सब्स्क्रिप्शन सहजपणे बदलता येईल.",
          color: "#ffa415",
        },
        {
          question: "पूजा किटमध्ये कोणकोणती सामग्री असते?",
          answer:
            "प्रत्येक किटमध्ये रोजच्या किंवा खास पूजेसाठी लागणारी सर्व आवश्यक सामग्री असते. सर्व साहित्य अशा प्रकारे पॅक केलेले असते की तुम्ही सहजतेने पूजा करू शकता.",
          color: "#fc5528",
        },
        {
          question: ". पूजा किट किती वेळा घरपोच मिळू शकते?",
          answer:
            "तुम्ही मासिक, त्रैमासिक किंवा वार्षिक डिलिव्हरी पर्याय निवडू  शकता. तुमच्या पूजेच्या वेळेनुसार  योग्य पर्याय निवडा.",
          color: "#8139e7",
        },
        {
          question: "Are the kits affordable?",
          answer:
            "Yes, the kits are priced to be budget-friendly. You can maintain your spiritual practices without spending too much.",
          color: "#8139e7",
        },
        {
          question: "मला पूजेचे साहित्य वेगळे आणावे लागेल का?",
          answer:
            "नाही, आम्ही सर्व पवित्र पूजासामग्री पुरवतो. तुम्हाला फक्त लाईव्ह सेशनमध्ये सहभागी होण्यासाठी एक डिव्हाइस (फोन/लॅपटॉप) लागेल, आणि तुम्ही भक्तीभावाने पूजा करू शकता.",
          color: "#8139e7",
        },
      ],

      metaTitle: "Puja Kit Subscription – Monthly, Quarterly, & Annual Plans",
      metaDescription:
        "Order ready-to-use puja kits with all the samagri needed for your rituals. A simple, devotional service that brings tradition to your doorstep.",
      cannonicalLink: "https://www.myomnamo.com/services/puja-kit-services",
      breadcrumbSchema: {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.myomnamo.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Puja Booking",
            item: "https://www.myomnamo.com/services/puja-kit-services",
          },
        ],
      },

      webpageSchema: {
        "@context": "http://schema.org",
        "@type": "WebPage",
        name: "Puja Kit Subscription – Monthly, Quarterly, & Annual Plans",
        url: "https://www.myomnamo.com/services/puja-kit-services",
        description:
          "Order ready-to-use puja kits with all the samagri needed for your rituals. A simple, devotional service that brings tradition to your doorstep.",
        publisher: {
          "@type": "Organization",
          name: "Myomnamo",
        },
      },

      faqSchema: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: " What are the ingredients in the puja kit ?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Each kit includes all the necessary ingredients for daily or special rituals. Everything is packed to help you perform your puja with ease.",
            },
          },
          {
            "@type": "Question",
            name: " How often can I get the puja kit delivered ?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "You can choose monthly, quarterly, or yearly delivery. Pick the option that best fits your worship routine.",
            },
          },
          {
            "@type": "Question",
            name: "Are the kits affordable?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, the kits are priced to be budget-friendly. You can maintain your spiritual practices without spending too much.",
            },
          },
          {
            "@type": "Question",
            name: "Can I change my subscription later?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, you can change or update your plan anytime. We make it easy to adjust your subscription as per your needs.",
            },
          },
        ],
      },
      metaData: {
        title: "Puja Kit Subscription – Monthly, Quarterly, & Annual Plans",
        description:
          "Order ready-to-use puja kits with all the samagri needed for your rituals. A simple, devotional service that brings tradition to your doorstep.",
        image: "https://www.myomnamo.com/assets/images/new/logo.png",
        url: "https://www.myomnamo.com/services/puja-kit-services",
        siteName: "Myomnamo",
        locale: "en_IN",
      },
      mainContent:
        "तुमच्या दारापर्यंत पूर्ण पूजा साहित्य किट मासिक, त्रैमासिक किंवा वार्षिक स्वरूपात परवडणाऱ्या दरात मिळवा.प्रत्येक किटमध्ये तुमच्या रोजच्या किंवा विशेष पूजनासाठी लागणारे सर्व साहित्य समाविष्ट आहे, त्यामुळे तुमचा वेळ आणि मेहनत वाचते. तुमच्या गरजेनुसार सोयीस्कर आणि सुलभ सब्स्क्रिप्शनद्वारे आपल्या परंपरांशी जोडलेले राहा.MyOmnamo वर विश्वास ठेवा — तुमची पूजा सोपी, व्यवस्थित आणि त्रासमुक्त करण्यासाठी आम्ही आहोत, जेणेकरून तुम्ही मनापासून भक्तीत रमू शकता",
    },

    // E-store
    {
      headerName: "ऑनलाइन पूजा साहित्य विक्री केंद्र",
      Imgabout1: About1,
      Imgabout2: Ecart,
      tagLine: "मंदिरातील पवित्र पूजेचा अनुभव घ्या",
      serviceBannerImg: EstoreBannerImg,
      route: "/my-store",
      serviceName: "e-store",
      whychooseUs: [
        {
          title: 'फक्त खऱ्या  वस्तू ',
          description: 'आम्ही १००% खरे आणि पारंपरिक पूजा साहित्य देतो, जे विश्वासू उद्योजकांकडून च घेतले जाते, ज्यामुळे विधींची पवित्रता टिकते.'
        },
        {
          title: 'सर्व काही एका ठिकाणी असणारे पूजा किट',
          description: 'तयार वापरासाठी किटमध्ये विशिष्ट पूजांसाठी लागणारे सर्व आवश्यक साहित्य असते, ज्यामुळे वेळ वाचतो आणि काहीही गोंधळ होत नाही.'
        },
        {
          title: 'विविध प्रकारच्या वस्तू',
          description: 'प्रत्येक पूजेसाठी दर्जेदार अगरबत्ती, धूप, कापूर आणि पवित्र वस्तूंचा विस्तृत संग्रह बघा.'
        },
        {
          title: 'संपूर्ण भारतात होम डिलिव्हरी',
          description: 'प्रत्येक पूजा वस्तूची शुद्धता आणि ताजेपणा जपण्यासाठी आम्ही सुरक्षित पॅकिंगसह भारतात कुठेही डिलिव्हरी करतो.'
        },
        {
          title: 'भक्तांचा विश्वास',
          description: 'हजारो समाधानी ग्राहक वेळेवर डिलिव्हरी आणि आमच्या निवडक पूजेच्या साहित्याच्या आध्यात्मिक मूल्यांवर विश्वास ठेवतात.'
        },
        {
          title: 'सोपे ऑनलाइन ऑर्डरिंग',
          description: 'सुरक्षित पेमेंट पर्याय आणि घरपोच डिलिव्हरीसह तुमच्या सर्व आध्यात्मिक गरजांसाठी सहज खरेदीचा अनुभव घ्या.'
        }
      ],
      whychooseUsTitle: 'Myomnamo सोप्या आणि पारंपरिक पद्धतीने पूजा सेवा देते, ज्यावर हजारो भक्तांचा विश्वास आहे.',
      howItWorksMainHeading: "विक्रीकेंद्रामुळे पूजा खरेदी झाली सोपी आणि सुलभ",
      howItWorks: [
        {
          howItWorksTitle: "फक्त एक क्लिक करा आणि निवडा",
          howItWorksDesc:
            "आमच्या विविध प्रकारच्या पूजा साहित्य पाहा. तुमच्या आध्यात्मिक गरजेनुसार वेगवेगळं पूजा साहित्य किंवा संपूर्ण पूजा किट निवडा.",
        },
        {
          howItWorksTitle: "ऑर्डर करा आणि पेमेंट करा",
          howItWorksDesc:
            "वस्तू तुमच्या कार्टमध्ये समाविष्ट करा , सुरक्षितरित्या पेमेंट करा आणि तुमच्या सोयीच्या पेमेंट पर्यायांची निवड करा — एक सोपा आणि सुरळीत खरेदी अनुभव घ्या.",
        },
        {
          howItWorksTitle: "ऑर्डर मिळवा आणि पूजा करा",
          howItWorksDesc:
            "तुमची  ओर्डेर तुमच्या दारापर्यंत पोहोचवली  जाईल. सर्व साहित्य  ताजे व शुध्द असून, तुम्ही शांततेने पूजा करू शकता.",
        },
      ],
      testimonials: [
        {
          Desc: "मी लक्ष्मीची मूर्ती आणि रुद्राक्ष माळ मागवली होती, आणि गुणवत्ता खूपच उत्कृष्ट होती. वस्तू नीट पॅक करून वेळेवर पोहोचवण्यात आल्या. खूप समाधान वाटलं.",
          name: "पूजा मोरे",
          location: "पुणे",
        },
        {
          Desc: "मी संपूर्ण पूजा किट घेतली आणि त्यामुळे माझे विधी खूप सोपे झाले. सर्व साहित्य प्रामाणिक आणि आध्यात्मिक दृष्ट्या पवित्र होतं. नक्कीच शिफारस करेन.",
          name: "विकास राठी",
          location: "बँगलोर",
        },
        {
          Desc: "मी ई-स्टोअरमधून अगरबत्ती आणि शंख घेतला. डिलिव्हरी खूप लवकर झाली आणि पॅकिंग देखील उत्तम होतं. नक्कीच पुन्हा खरेदी करेन.",
          name: "मीनल शिंदे",
          location: "जयपूर",
        },
        {
          Desc: "Myomnamo ई-स्टोअरमधून खरेदी करणं खूप सोपं आणि सोयीचं होतं. मला सगळी पूजा साहित्य एकाच ठिकाणी मिळाली, वेगवेगळ्या दुकानांत जायची गरजच भासली नाही.",
          name: "सागर शिंदे",
          location: "मुंबई",
        },
      ],
      FaqObj: [
        {
          question: "तुम्ही कोणते वस्तू देता?",
          answer:
            "आम्ही पूजा साहित्य, संपूर्ण पूजा किट्स, मूर्ती, अगरबत्ती, फुले आणि दैनंदिन पूजा तसेच खास समारंभांसाठी लागणाऱ्या सर्व वस्तू पुरवतो.",
          color: "#ffa415",
        },
        {
          question: "तुम्ही जलद डिलिव्हरी देता का?",
          answer:
            "होय! आम्ही वेळेवर आणि विश्वासू डिलिव्हरीची खात्री देतो, जेणेकरून तुम्हाला पूजेसाठी किंवा सणासाठी लागणाऱ्या वस्तू वेळेवर मिळतील. ",
          color: "#fc5528",
        },
        {
          question: "वस्तू  खऱ्या  आणि पवित्र आहेत का?",
          answer:
            "होय, आमची उत्पादने विश्वासू विक्रेत्यांकडून मिळवली जातात आणि अनेक वस्तू आध्यात्मिकदृष्ट्या पवित्र असतात.",
          color: "#8139e7",
        },
      ],
      sectionTitle: "तुमचा एकमेव ऑनलाइन ई-स्टोअर",
      metaTitle: "Online Puja Samagri Store - Buy Puja Items at Myomnamo",
      metaDescription:
        "Online shopping for authentic Puja samagri and puja items at Myomnamo. Explore a wide range of spiritual products for all your rituals and ceremonies. Fast delivery and trusted quality.",
      cannonicalLink: "https://www.myomnamo.com/services/e-store",
      breadcrumbSchema: {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.myomnamo.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Puja Samagri Store",
            item: "https://www.myomnamo.com/services/e-store",
          },
        ],
      },
      webpageSchema: {
        "@context": "http://schema.org",
        "@type": "WebPage",
        name: "Online Puja Samagri Store - Buy Puja Items at Myomnamo",
        url: "https://www.myomnamo.com/services/e-store",
        description:
          "Online shopping for authentic Puja samagri and puja items at Myomnamo. Explore a wide range of spiritual products for all your rituals and ceremonies. Fast delivery and trusted quality.",
        publisher: {
          "@type": "Organization",
          name: "Myomnamo",
        },
      },
      faqSchema: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "What products do you offer?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "We provide puja samagri, complete kits, idols, incense, flowers, and everything needed for daily rituals or special ceremonies.",
            },
          },
          {
            "@type": "Question",
            name: "Do you offer fast delivery?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes! We ensure quick and reliable delivery so you get your items on time for your puja or festival.",
            },
          },
          {
            "@type": "Question",
            name: "Are the products authentic and blessed?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, our products are sourced from trusted vendors and many items are spiritually blessed.",
            },
          },
        ],
      },
      metaData: {
        title: "Online Puja Samagri Store - Buy Puja Items at Myomnamo",
        description:
          "Online shopping for authentic Puja samagri and puja items at Myomnamo. Explore a wide range of spiritual products for all your rituals and ceremonies. Fast delivery and trusted quality.",
        image: "https://www.myomnamo.com/assets/images/new/logo.png",
        url: "https://www.myomnamo.com/services/e-store",
        siteName: "Myomnamo",
        locale: "en_IN",
      },

      mainContent:
        "तुमचे सर्व पूजा साहित्य आता घरबसल्या ऑनलाइन मिळवा ! पूजा साहित्य, परीपूर्ण पूजा किट्स, मूर्ती, अगरबत्ती आणि बरेच काही एका ठिकाणी.दररोजच्या पूजांसाठी असो किंवा खास सण-समारंभांसाठी, तुमच्या विधींसाठी सर्व काही येथे तयार मिळवा. अनेक दुकानं फिरण्याची गरज नाही, फक्त एक क्लिक करा आणि सामान तुमच्या घरी मिळवा. ताजी  फुले, धार्मिक भेंट आणि योग्य वस्तूंसह प्रत्येक विधी अधिक अर्थपूर्ण करा. सांस्कृतिक परंपरा साजरा करा सोप्या आणि सुखद पद्धतीने, कारण तुमच्याकडे सर्व गरजेच्या वस्तू आता उपलब्ध आहेत. प्रत्येक आध्यात्मिक कार्यासाठी योग्य वस्तूंसह तुमचा विश्वास अजून  मजबूत करा.",
    },

    // Darshan Booking 
    {
      headerName: "ऑनलाइन दर्शन बुकिंग",
      Imgabout1: About1,
      Imgabout2: templeBooking,
      tagLine: "मंदिर पूजांद्वारे दिव्यता अनुभवा",
      sectionTitle: "सोप्या पद्धतीने मंदिर दर्शन ऑनलाइन बुक करा",
      serviceBannerImg: DarshanBookingBannerImg,
      serviceName: "darshan-booking",
      cannonicalLink: "https://www.myomnamo.com/services/darshan-booking",
      route: "/darshan-booking",
      whychooseUs: [
        {
          title: 'रांगा टाळा',
          description: 'आत्ताच्या धकाधकीच्या जीवनात आणि अत्यंत गर्दीभरया मंदिरात मनासारखं दर्शन व्हाव म्हणून आधीच ऑनलाइन बुक करा, लांबच्या रांगांपासून बचत करा आणि शांत मंदिर भेटीसाठी मौल्यवान वेळ मिळवा.'
        },
        {
          title: 'सोपं बुकिंग प्रक्रिया',
          description: 'आमच एप  वापरण्यासाठी  अनुकूल प्लॅटफॉर्म तुम्हाला फक्त काही सोप्या टप्प्यांत दर्शन बुक करण्याची सोय करतो, ज्यामुळे प्रक्रिया जलद आणि सोयीची होते.'
        },
        {
          title: 'सोप्या पद्धतीने योजना करा',
          description: 'तुमच्या प्रवासाच्या वेळापत्रकानुसार आवडती तारीख आणि वेळ निवडून मंदिर भेटीची सोपी व्यवस्था करा.'
        },
        {
          title: 'सर्वांसाठी योग्य',
          description: 'कुटुंब सहित असाल, ज्येष्ठ नागरिक असाल किंवा एकटे असाल, आमची सेवा सर्वांसाठी सहज आणि तणावमुक्त अनुभव सुनिश्चित करते.'
        },
        {
          title: 'खात्रीशीर प्रवेश',
          description: 'सण, खास पूजा किंवा दैनंदिन प्रार्थनेसाठी पुष्टी केलेल्या दर्शन बुकिंगने तुमची जागा सुनिश्चित करा.'
        },
        {
          title: 'सुसंगठित भेट',
          description: 'दर्शन बुक केल्यामुळे तुमची भेट अधिक व्यवस्थित होईल, ज्यामुळे तुम्हाला प्रार्थना, चिंतन आणि आध्यात्मिक समाधानासाठी पुरेसा वेळ मिळेल.'
        }
      ],
      whychooseUsTitle: 'Myomnamo सोप्या आणि पारंपरिक पद्धतीने पूजा सेवा देते, ज्यावर हजारो भक्तांचा विश्वास आहे.',
      howItWorksMainHeading: "सोपं आणि वेळ वाचवणारं दर्शन बुकिंग",
      howItWorks: [
        {
          howItWorksTitle: "आपले मंदिर निवडा",
          howItWorksDesc:
            "दर्शनासाठी आपले मंदिर आणि आवडती तारीख निवडा. गर्दीच्या काळातही सहजपणे आपल्या भेटीची योजना करा. ",
        },
        {
          howItWorksTitle: "आपला स्लॉट बुक करा",
          howItWorksDesc:
            "फक्त काही मिनिटांत ऑनलाइन दर्शन स्लॉट बुक करा. लांबच्या रांगा टाळा आणि शांत, तणावमुक्त मंदिराचा अनुभव घ्या.",
        },
        {
          howItWorksTitle: "अधिकृत करा",
          howItWorksDesc:
            "तुमच्या ईमेल किंवा SMS द्वारे त्वरित बुकिंगची पुष्टी मिळवा. मंदिरात तुमची माहिती दाखवा आणि तणावमुक्त भेटीचा आनंद घ्या.",
        },
      ],
      testimonials: [
        {
          Desc: "मंदिर दर्शन ऑनलाइन बुक केल्याने माझा खूप वेळ वाचला! लांबच्या रांगांमध्ये उभे राहावे लागले नाही आणि प्रक्रिया खूप सुरळीत झाली. खरंच एक दिव्य अनुभव.",
          name: "रोहित पवार",
          location: "येवला",
        },
        {
          Desc: "मी माझ्या कुटुंबासाठी VIP दर्शन बुक केलं, आणि सगळं अगदी परिपूर्णपणे पार पडलं. पुष्टी त्वरित मिळाली आणि आम्हाला शांतपणे दर्शनाचा आनंद घेता आला.",
          name: "नेहा तिळे",
          location: "नागपूर",
        },
        {
          Desc: "या सेवेमुळे मंदिर भेट तणावमुक्त झाली. मी माझं दर्शन आधीच  बुक केलं आणि कोणत्याही त्रासाशिवाय सहज प्रवेश झाला.खूप शिफारस करतो.",
          name: "अमित पाटील",
          location: "जयपूर",
        },
        {
          Desc: "माझे वृद्ध पालक प्रवास न करता दर्शन करू शकले. हे आमच्यासाठी खूप महत्वाचं होतं. धन्यवाद, Myomnamo.",
          name: "भावना साळुंखे",
          location: "नांदेड",
        },

        {
          Desc: "प्रक्रिया सोपी होती आणि दर्शन Myomnamo ने व्यवस्थित आयोजित केले.",
          name: "गौरव जाधव",
          location: "रत्नागिरी",
        },
      ],
      FaqObj: [
        {
          question: "दर्शन बुकिंग सेवा म्हणजे काय?",
          answer:
            "आमची सेवा तुम्हाला मंदिर दर्शन ऑनलाइन बुक करण्याची सोय देते, ज्यामुळे तुम्हाला एक तणावमुक्त आणि आध्यात्मिक अनुभव मिळतो.",
          color: "#ffa415",
        },
        {
          question: "मी एकाच वेळी अनेक लोकांसाठी दर्शन बुक करू शकतो का?",
          answer:
            "होय, तुम्ही स्वतःसाठी, तुमच्या कुटुंबासाठी किंवा मित्रांसाठी एकाच वेळी दर्शन बुक करू शकता. बुकिंग करताना त्यांची माहिती फक्त भरावी लागेल.",
          color: "#fc5528",
        },
        {
          question: "विशेष कार्यक्रमांसाठी ऑनलाइन बुकिंग करता येते का?",
          answer:
            "होय, तुम्ही सण, खास पूजा किंवा दैनंदिन दर्शनासाठीही, गर्दीच्या काळातही, दर्शन ऑनलाइन बुक करू शकता.",
          color: "#8139e7",
        },
        {
          question: "VIP किंवा खास दर्शन तिकिटं उपलब्ध आहेत का?",
          answer:
            "होय, आम्ही काही निवडक मंदिरांमध्ये VIP किंवा एक्सप्रेस दर्शन बुकिंगची सोय देतो.",
          color: "#8139e7",
        },
      ],
      metaTitle:
        "Online Temple Darshan Booking - Plan Your Visit Now with Myomnamo",
      metaDescription:
        "Book temple darshan online and avoid waiting. Secure your slot, receive instant confirmation, and focus on your prayers. Start your booking now!",
      canonicalLink: "https://www.myomnamo.com/services/darshan-booking",
      breadcrumbSchema: {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.myomnamo.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Darshan Booking",
            item: "https://www.myomnamo.com/services/darshan-booking",
          },
        ],
      },
      webpageSchema: {
        "@context": "http://schema.org",
        "@type": "WebPage",
        name: "Online Temple Darshan Booking - Plan Your Visit Now with Myomnamo",
        url: "https://www.myomnamo.com/services/darshan-booking",
        description:
          "Book temple darshan online and avoid waiting. Secure your slot, receive instant confirmation, and focus on your prayers. Start your booking now!",
        publisher: {
          "@type": "Organization",
          name: "Myomnamo",
        },
      },
      faqSchema: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "What is the Darshan Booking service?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Our service allows you to book temple darshan online for a hassle-free spiritual experience.",
            },
          },
          {
            "@type": "Question",
            name: "Can I book darshan for multiple people?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, you can book darshan for yourself, your family, or your friends in one go. Just add their details during booking.",
            },
          },
          {
            "@type": "Question",
            name: "Is online booking available for special events?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, you can book darshan for festivals, special pujas, or daily visits — even during peak times.",
            },
          },
          {
            "@type": "Question",
            name: "Are VIP or special darshan tickets available?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, we offer VIP or express darshan bookings at select temples.",
            },
          },
        ],
      },
      metaData: {
        title:
          "Online Temple Darshan Booking - Plan Your Visit Now with Myomnamo",
        description:
          "Book temple darshan online and avoid waiting. Secure your slot, receive instant confirmation, and focus on your prayers. Start your booking now!",
        image: "https://www.myomnamo.com/assets/images/new/logo.png",
        url: "https://www.myomnamo.com/services/darshan-booking",
        siteName: "Myomnamo",
        locale: "en_IN",
      },
      mainContent:
        "आपल्या मंदिराच्या भेटीची योजना अगदी सोप्या पद्धतीने आयोजित  करा! दर्शन आधीच बुक करा आणि लांबच्या रांगा टाळा. तुम्ही सणासाठी, खास पूजेसाठी किंवा दैनंदिन प्रार्थनेसाठी येत असाल तरी, फक्त काही सोप्या टप्प्यांत तुमची जागा सुरक्षित होईल. शांततेने मंदिर भेट द्या, प्रार्थना करा आणि प्रतिक्षा करण्याच्या तणावा शिवाय आशिर्वाद मिळवा. हे विशेषतः कुटुंबीयांसाठी, वयस्कर भाविकांसाठी किंवा ज्यांना सुलभ दर्शन अनुभव हवा आहे त्यांच्यासाठी उपयुक्त आहे. तुमच्या भक्तीवर लक्ष केंद्रित करा आणि पवित्र वातावरणात पूर्णपणे मग्न व्हा. दर्शन बुक केल्याने तुमची भेट अधिक सुव्यवस्थित होते, ज्यामुळे तुम्हाला प्रार्थना आणि चिंतनासाठी अधिक वेळ मिळतो.",
    },

    // Puja At Temple
    {
      headerName: "मंदिर पूजा बुकिंग",
      Imgabout1: About1,
      Imgabout2: poojaAtTemple,
      tagLine: "मंदिर पूजांद्वारे सुंदर अनुभव घ्या ",
      serviceBannerImg: PujaAtTempleBannerImg,
      route: "/puja-at-temple",
      cannonicalLink: "https://www.myomnamo.com/services/temple-puja-booking",
      serviceName: "temple-puja",
      sectionTitle: "मंदिरात पवित्र पूजा करा",
      whychooseUs: [
        {
          title: 'सोपे बुकिंग',
          description: 'कोणतीही मंदिर पूजा ऑनलाइन कधीही, कुठूनही, जलद, सोप्या आणि तणावमुक्त पद्धतीने बुक करु शकत.'
        },
        {
          title: 'अनुभवी पंडित',
          description: 'आमचे कुशल आणि प्रमाणित पंडित पूर्ण भक्ती आणि परंपरेनुसार सर्व  विधी पार पाडतात.'
        },
        {
          title: 'गरजेनुसार  सेवा',
          description: 'तुमच्या गरजा, प्रसंग आणि आवडीनुसार पूजा निवडा आणि अर्थपूर्ण आध्यात्मिक अनुभव घ्या.'
        },
        {
          title: 'लाईव्ह  अपडेट्स',
          description: 'आत्मिक समाधानासाठी  पूजा स्थिती आणि वेळेची त्वरित माहिती मिळवा.'
        },
        {
          title: 'सुरक्षित पेमेंट ',
          description: 'पूर्ण डेटा एन्क्रिप्शन आणि संरक्षणासह सुरक्षित ऑनलाइन पेमेंट  करा.'
        },
        {
          title: 'एकाच ठिकाणी आध्यात्मिक सेवा',
          description: 'सर्व आध्यात्मिक सेवा, पंडित बुकिंग, पूजा आणि दर्शन तिकिटे एकाच ठिकाणी मिळवा.'
        }
      ],
      whychooseUsTitle: 'Myomnamo सोप्या आणि पारंपरिक पद्धतीने पूजा सेवा देते, ज्यावर हजारो भक्तांचा विश्वास आहे.',
      howItWorksMainHeading: "पवित्र आशीर्वाद मिळवा",
      howItWorks: [
        {
          howItWorksTitle: "तुमची पूजा निवडा",
          howItWorksDesc:
            "सोप्या पुजांपासून ते विस्तृत विधींपर्यंत तुमचा योग्य पर्याय  निवडा, आणि तुमच्या आध्यात्मिक इच्छांनुसार  विधी करा.",
        },
        {
          howItWorksTitle: "दिव्यता अनुभवा",
          howItWorksDesc:
            "पवित्र विधींमध्ये सहभागी व्हा, मंत्र जपा आणि सकारात्मकता व आरोग्यासाठी आशीर्वाद मिळवा.",
        },
        {
          howItWorksTitle: "सोप्या पद्धतीने बुक करा",
          howItWorksDesc:
            "अर्पण  क्रियेपासून पवित्र ठिकाण तयार करण्यापर्यंत, आम्ही सर्वकाही तयार ठेवतो, जेणेकरून तुम्ही तुमच्या प्रार्थनेवर निश्चिंतपणे लक्ष केंद्रित करू शकता..",
        },
      ],
      testimonials: [
        {
          Desc: "मी मंदिरात पूजा बुक केली, आणि सगळं अगदी परिपूर्णपणे आयोजित केले होते. विधी अतिशय सुंदर पद्धतीने पार पडले आणि मला खरंच आशीर्वाद मिळाला असं वाटलं.",
          name: "अंजली राऊत",
          location: "कोल्हापूर",
        },
        {
          Desc: "मंदिर पूजा ऑनलाइन बुक करणं खूप सोयीचं होतं. कोणतीही लांबली वाट पाहावी लागली नाही, सर्व काही नीटपणे आयोजित होतं आणि प्रसादाची डिलिव्हरीही खूप छान होती.",
          name: "विकास माने",
          location: "दिल्ली ",
        },
        {
          Desc: "पूजा अगदी आश्वासनाप्रमाणेच, पूर्ण भक्ती आणि काळजीने पार पडली. हा एक शांत आणि दिव्य अनुभव होता. मनापासून शिफारस करते.",
          name: "प्रिया कदम",
          location: "वाशी ",
        },
        {
          Desc: "आम्हाला दक्षिण भारतीय मंदिरात पूजा करायची होती, आणि Myomnamo ती सहजतेने पार पाडली.",
          name: "अभय नाडकर्णीं",
          location: "मुंबई ",
        },
        {
          Desc: "Myomnamo  ने  माझ्या मुलाच्या वाढदिवसासाठी खास मंदिर पूजा बुक करण्यात मदत केली. खरंच आशीर्वाद मिळाल्यासारखं वाटलं.",
          name: "राहुल चितळे",
          location: "सोलापूर ",
        },
      ],
      FaqObj: [
        {
          question: ". मंदिरातील पूजा सेवा म्हणजे काय?",
          answer:
            "आमची सेवा तुम्हाला मंदिरातील पूजा ऑनलाइन बुक करण्याची सोय देते, ज्यामुळे तुम्हाला एक सुरळीत आणि तणावमुक्त अनुभव मिळतो.",
          color: "#ffa415",
        },
        {
          question: "मी पूजा कशी बुक करू?",
          answer:
            "तुम्ही ऑनलाइन किंवा मंदिरात बुक करू शकता. पूजा प्रकार, तारीख आणि वेळ निवडू शकता.",
          color: "#fc5528",
        },
        {
          question: "कोणत्या प्रकारच्या पूजांचा पर्याय आहे?",
          answer:
            "आम्ही वाढदिवस, वर्धापनदिन, सण, वैयक्तिक प्रार्थना आणि खास विधींसाठी पूजा सेवा देतो.",
          color: "#8139e7",
        },
        {
          question: "खास किंवा खाजगी पूजा उपलब्ध आहेत का?",
          answer:
            "होय, काही मंदिरांमध्ये वैयक्तिकृत विधींसह खास खाजगी पूजा करता येतात.",
          color: "#8139e7",
        },
      ],
      metaTitle: "Book Temple Puja Online - Sacred Rituals for Every Occasion",
      metaDescription:
        "Book a temple puja for birthdays, anniversaries, or festivals. Experience sacred rituals with care and devotion. Focus on prayers while we handle the rest.",
      canonicalLink: "https://www.myomnamo.com/services/temple-puja-booking",
      breadcrumbSchema: {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.myomnamo.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Temple Puja",
            item: "https://www.myomnamo.com/services/temple-puja-booking",
          },
        ],
      },
      webpageSchema: {
        "@context": "http://schema.org",
        "@type": "WebPage",
        name: "Book Temple Puja Online - Sacred Rituals for Every Occasion",
        url: "https://www.myomnamo.com/services/temple-puja-booking",
        description:
          "Book a temple puja for birthdays, anniversaries, or festivals. Experience sacred rituals with care and devotion. Focus on prayers while we handle the rest.",
        publisher: {
          "@type": "Organization",
          name: "Myomnamo",
        },
      },
      faqSchema: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "What is the Puja at Temple service?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Our service allows you to book a temple puja online, ensuring a smooth and hassle-free experience.",
            },
          },
          {
            "@type": "Question",
            name: "How do I book a puja?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "You can book online or at the temple. Choose the puja type, date, and time.",
            },
          },
          {
            "@type": "Question",
            name: "What types of pujas are available?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "We offer pujas for birthdays, anniversaries, festivals, personal prayers, and special ceremonies.",
            },
          },
          {
            "@type": "Question",
            name: "Are special or private pujas available?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, some temples offer private pujas with personalized rituals.",
            },
          },
        ],
      },
      metaData: {
        title: "Book Temple Puja Online - Sacred Rituals for Every Occasion",
        description:
          "Book a temple puja for birthdays, anniversaries, or festivals. Experience sacred rituals with care and devotion. Focus on prayers while we handle the rest.",
        image: "https://www.myomnamo.com/assets/images/new/logo.png",
        url: "https://www.myomnamo.com/services/temple-puja-booking",
        siteName: "Myomnamo",
        locale: "en_IN",
      },
      mainContent:
        "शांत आणि पवित्र पूजेने तुमची मंदिर भेट अधिक खास बनवा.  वाढदिवस, वर्धापनदिन, सण किंवा वैयक्तिक प्रार्थनेसाठी पूजा बुक करा.  विधी काळजीपूर्वक आणि श्रद्धेने पार पडतील, ज्यामुळे तुमच्या आयुष्यात सकारात्मकता आणि आशिर्वाद येतील. लहानशी पूजा असो किंवा संपूर्ण विधी, पवित्र वातावरण अनुभवा आणि तुमच्या श्रद्धेशी खोलवर जोडले जा. ही सेवा व्यक्ती, कुटुंब किंवा समूहांसाठी योग्य आहे. इतर सोय आम्ही करू तुम्ही पूजेवर लक्ष केद्रिंत करा. प्रत्येक भेट खास आणि सकारात्मक ऊर्जा भरलेली बनवा.",
    },
  ]